function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import memoize from 'memoizee';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import deepEqual from 'fast-deep-equal';
import Log from '@deephaven/log';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContextActions, Stack, Menu, Page, Popper, ThemeExport, Tooltip, Button, ContextActionUtils, SlideTransition } from '@deephaven/components';
import { Grid, GridRange, GridUtils, isEditableGridModel, isExpandableGridModel, isDeletableGridModel, isExpandableColumnGridModel } from '@deephaven/grid';
import { dhEye, dhFilterFilled, dhGraphLineUp, dhTriangleDownSquare, vsClose, vsCloudDownload, vsEdit, vsFilter, vsMenu, vsReply, vsRuby, vsSearch, vsSplitHorizontal, vsSymbolOperator, vsTools } from '@deephaven/icons';
import { DateUtils, Formatter, FormatterUtils, TableUtils, isSortDirection } from '@deephaven/jsapi-utils';
import { assertNotNull, copyToClipboard, EMPTY_ARRAY, EMPTY_MAP, Pending, PromiseUtils, ValidationError, getOrThrow } from '@deephaven/utils';
import { Type as FilterType } from '@deephaven/filters';
import throttle from 'lodash.throttle';
import debounce from 'lodash.debounce';
import clamp from 'lodash.clamp';
import { getFormatColumns } from "./sidebar/conditional-formatting/ConditionalFormattingUtils.js";
import PendingDataBottomBar from "./PendingDataBottomBar.js";
import IrisGridCopyHandler from "./IrisGridCopyHandler.js";
import FilterInputField from "./FilterInputField.js";
import { CopyCellKeyHandler, ClearFilterKeyHandler, CopyKeyHandler, ReverseKeyHandler } from "./key-handlers/index.js";
import { IrisGridCellOverflowMouseHandler, IrisGridColumnSelectMouseHandler, IrisGridColumnTooltipMouseHandler, IrisGridContextMenuHandler, IrisGridCopyCellMouseHandler, IrisGridDataSelectMouseHandler, IrisGridPartitionedTableMouseHandler, IrisGridFilterMouseHandler, IrisGridRowTreeMouseHandler, IrisGridSortMouseHandler, IrisGridTokenMouseHandler, PendingMouseHandler } from "./mousehandlers/index.js";
import ToastBottomBar from "./ToastBottomBar.js";
import IrisGridMetricCalculator from "./IrisGridMetricCalculator.js";
import IrisGridModelUpdater from "./IrisGridModelUpdater.js";
import IrisGridRenderer from "./IrisGridRenderer.js";
import { createDefaultIrisGridTheme } from "./IrisGridTheme.js";
import ColumnStatistics from "./ColumnStatistics.js";
import "./IrisGrid.css";
import AdvancedFilterCreator from "./AdvancedFilterCreator.js";
import { Aggregations, AggregationEdit, AggregationUtils, ChartBuilder, CustomColumnBuilder, OptionType, RollupRows, TableCsvExporter, TableSaver, VisibilityOrderingBuilder, DownloadServiceWorkerUtils } from "./sidebar/index.js";
import { DEFAULT_REGISTRY, IrisGridContext } from "./IrisGridContextProvider.js";
import IrisGridModel from "./IrisGridModel.js";
import IrisGridUtils from "./IrisGridUtils.js";
import CrossColumnSearch from "./CrossColumnSearch.js";
import { isPartitionedGridModel } from "./PartitionedGridModel.js";
import IrisGridPartitionSelector from "./IrisGridPartitionSelector.js";
import SelectDistinctBuilder from "./sidebar/SelectDistinctBuilder.js";
import PluginTableOptionsErrorBoundary from "./sidebar/PluginTableOptionsErrorBoundary.js";
import AdvancedSettingsType from "./sidebar/AdvancedSettingsType.js";
import AdvancedSettingsMenu from "./sidebar/AdvancedSettingsMenu.js";
import SHORTCUTS from "./IrisGridShortcuts.js";
import ConditionalFormattingMenu from "./sidebar/conditional-formatting/ConditionalFormattingMenu.js";
import ConditionalFormatEditor from "./sidebar/conditional-formatting/ConditionalFormatEditor.js";
import IrisGridCellOverflowModal from "./IrisGridCellOverflowModal.js";
import GotoRow from "./GotoRow.js";
import { isMissingPartitionError } from "./MissingPartitionError.js";
import { NoPastePermissionModal } from "./NoPastePermissionModal.js";
import { isColumnHeaderGroup } from "./ColumnHeaderGroup.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('IrisGrid');
var VIEWPORT_LOADING_DELAY = 500;
var UPDATE_DOWNLOAD_THROTTLE = 500;
var SET_FILTER_DEBOUNCE = 250;
var SEEK_ROW_DEBOUNCE = 250;
var SET_CONDITIONAL_FORMAT_DEBOUNCE = 250;
var DEFAULT_AGGREGATION_SETTINGS = Object.freeze({
  aggregations: EMPTY_ARRAY,
  showOnTop: false
});
var UNFORMATTED_DATE_PATTERN = "yyyy-MM-dd'T'HH:mm:ss.SSSSSSSSS z";

/**
 * The subset of `IrisGridProps` that overrides how the grid presents its
 * model: theme, canvas renderer, extra mouse handlers, and the metric
 * calculator factory. Hosts that render `<IrisGrid>` on behalf of a plugin
 * (e.g. `GridWidgetPlugin`) accept this as a single passthrough bag so they
 * don't need to know each view concern by name, and plugins build it from
 * their own hooks. Kept as a `Pick` (not `Partial<IrisGridProps>`) so it can
 * never clobber structural props like `model` or `ref`.
 */

class IrisGrid extends Component {
  constructor(props) {
    var _model$layoutHints, _model$columns$0$name, _model$columns$;
    super(props);
    _defineProperty(this, "grid", void 0);
    _defineProperty(this, "lastFocusedFilterBarColumn", void 0);
    _defineProperty(this, "lastLoadedConfig", void 0);
    _defineProperty(this, "tooltip", void 0);
    _defineProperty(this, "pending", void 0);
    _defineProperty(this, "globalColumnFormats", void 0);
    _defineProperty(this, "dateTimeFormatterOptions", void 0);
    _defineProperty(this, "decimalFormatOptions", void 0);
    _defineProperty(this, "integerFormatOptions", void 0);
    _defineProperty(this, "truncateNumbersWithPound", void 0);
    _defineProperty(this, "showEmptyStrings", void 0);
    _defineProperty(this, "showNullStrings", void 0);
    _defineProperty(this, "showExtraGroupColumn", void 0);
    // When the loading scrim started/when it should extend to the end of the screen.
    _defineProperty(this, "loadingScrimStartTime", void 0);
    _defineProperty(this, "loadingScrimFinishTime", void 0);
    _defineProperty(this, "animationFrame", void 0);
    _defineProperty(this, "loadingTimer", void 0);
    _defineProperty(this, "tableSaver", void 0);
    _defineProperty(this, "crossColumnRef", void 0);
    _defineProperty(this, "isAnimating", void 0);
    _defineProperty(this, "filterInputRef", void 0);
    _defineProperty(this, "gotoRowRef", void 0);
    _defineProperty(this, "isCopying", void 0);
    _defineProperty(this, "toggleFilterBarAction", void 0);
    _defineProperty(this, "toggleSearchBarAction", void 0);
    _defineProperty(this, "toggleGotoRowAction", void 0);
    _defineProperty(this, "discardAction", void 0);
    _defineProperty(this, "commitAction", void 0);
    _defineProperty(this, "contextActions", void 0);
    _defineProperty(this, "tableUtils", void 0);
    _defineProperty(this, "keyHandlers", void 0);
    _defineProperty(this, "mouseHandlers", void 0);
    /**
     * The metric calculator factory most recently used to instantiate the
     * calculator currently stored in state. Used by `maybeRebuildMetricCalculator`
     * (called from `componentDidUpdate` when the `getMetricCalculator` prop
     * changes) to detect when a different factory is supplied and rebuild.
     */
    _defineProperty(this, "lastMetricCalculatorFactory", void 0);
    _defineProperty(this, "slideTransitionRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "bottomTransitionRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "getAdvancedMenuOpenedHandler", memoize(column => this.handleAdvancedMenuOpened.bind(this, column), {
      max: 100
    }));
    _defineProperty(this, "getAdvancedMenuToggleMaximizeHandler", memoize(column => this.handleAdvancedFilterToggleMaximize.bind(this, column), {
      max: 100
    }));
    _defineProperty(this, "getCachedAdvancedFilterMenuActions", memoize((model, column, advancedFilterOptions, sortDirection, formatter, isMaximized, onToggleMaximize) => /*#__PURE__*/_jsx(AdvancedFilterCreator, {
      model: model,
      column: column,
      onFilterChange: this.handleAdvancedFilterChange,
      onSortChange: this.handleAdvancedFilterSortChange,
      onDone: this.handleAdvancedFilterDone,
      options: advancedFilterOptions,
      sortDirection: sortDirection,
      formatter: formatter,
      tableUtils: this.tableUtils,
      isMaximized: isMaximized,
      onToggleMaximize: onToggleMaximize
    }), {
      max: 50
    }));
    _defineProperty(this, "getCachedOptionItems", memoize((isChartBuilderAvailable, isCustomColumnsAvailable, isFormatColumnsAvailable, isOrganizeColumnsAvailable, isRollupAvailable, isTotalsAvailable, isSelectDistinctAvailable, isExportAvailable, toggleFilterBarAction, toggleSearchBarAction, toggleGotoRowAction, isFilterBarShown, showSearchBar, canDownloadCsv, canToggleSearch, showGotoRow, hasAdvancedSettings) => {
      var optionItems = [];
      if (isChartBuilderAvailable) {
        optionItems.push({
          type: OptionType.CHART_BUILDER,
          title: 'Chart Builder',
          icon: dhGraphLineUp,
          order: 100
        });
      }
      if (isOrganizeColumnsAvailable) {
        optionItems.push({
          type: OptionType.VISIBILITY_ORDERING_BUILDER,
          title: 'Organize Columns',
          icon: dhEye,
          order: 200
        });
      }
      if (isFormatColumnsAvailable) {
        optionItems.push({
          type: OptionType.CONDITIONAL_FORMATTING,
          title: 'Conditional Formatting',
          icon: vsEdit,
          order: 300
        });
      }
      if (isCustomColumnsAvailable) {
        optionItems.push({
          type: OptionType.CUSTOM_COLUMN_BUILDER,
          title: 'Custom Columns',
          icon: vsSplitHorizontal,
          order: 400
        });
      }
      if (isRollupAvailable) {
        optionItems.push({
          type: OptionType.ROLLUP_ROWS,
          title: 'Rollup Rows',
          icon: dhTriangleDownSquare,
          order: 500
        });
      }
      if (isTotalsAvailable) {
        optionItems.push({
          type: OptionType.AGGREGATIONS,
          title: 'Aggregate Columns',
          icon: vsSymbolOperator,
          order: 600
        });
      }
      if (isSelectDistinctAvailable) {
        optionItems.push({
          type: OptionType.SELECT_DISTINCT,
          title: 'Select Distinct Values',
          icon: vsRuby,
          order: 700
        });
      }
      if (isExportAvailable && canDownloadCsv) {
        optionItems.push({
          type: OptionType.TABLE_EXPORTER,
          title: 'Download CSV',
          icon: vsCloudDownload,
          order: 800
        });
      }
      if (hasAdvancedSettings) {
        optionItems.push({
          type: OptionType.ADVANCED_SETTINGS,
          title: 'Advanced Settings',
          icon: vsTools,
          order: 900
        });
      }
      optionItems.push({
        type: OptionType.QUICK_FILTERS,
        title: 'Quick Filters',
        subtitle: toggleFilterBarAction.shortcut.getDisplayText(),
        icon: vsFilter,
        isOn: isFilterBarShown,
        onChange: toggleFilterBarAction.action,
        order: 1000
      });
      if (canToggleSearch) {
        optionItems.push({
          type: OptionType.SEARCH_BAR,
          title: 'Search Bar',
          subtitle: toggleSearchBarAction.shortcut.getDisplayText(),
          icon: vsSearch,
          isOn: showSearchBar,
          onChange: toggleSearchBarAction.action,
          order: 1100
        });
      }
      optionItems.push({
        type: OptionType.GOTO,
        title: 'Go to',
        subtitle: toggleGotoRowAction.shortcut.getDisplayText(),
        icon: vsReply,
        isOn: showGotoRow,
        onChange: toggleGotoRowAction.action,
        order: 1200
      });
      return Object.freeze(optionItems);
    }, {
      max: 1
    }));
    /**
     * Apply the `transformTableOptions` transform (if any) to the
     * default option list.
     * Catches exceptions so a buggy plugin can't break the grid, and collapses
     * duplicate `type` entries (last writer wins) before sorting by `order`.
     */
    _defineProperty(this, "getCachedTransformedOptionItems", memoize((items, transformTableOptions) => {
      if (transformTableOptions == null) {
        return items;
      }
      var transformedItems;
      try {
        transformedItems = transformTableOptions(items);
      } catch (err) {
        log.error('transformTableOptions threw an error; falling back to defaults.', err);
        return items;
      }
      // Collapse duplicate `type` entries before sorting. A duplicate `type`
      // would otherwise collide on the `<Menu>` / `<Page>` React key and cause
      // incorrect page reuse. Per the documented composition rule (see the
      // package README), the last writer wins: a later entry — e.g. from a
      // downstream middleware — overrides an earlier one with the same type.
      // `Map.set` keeps the most recent value while preserving the original
      // insertion slot, so an override stays in place unless it changes
      // `order`.
      var byType = new Map();
      transformedItems.forEach(item => {
        byType.set(String(item.type), item);
      });
      // Stably sort by ascending `order`. Items without an `order` sink to
      // the end of the menu (default `Infinity`), while items with an `order`
      // are positioned by their weight. Decorate-sort-undecorate guarantees
      // stability regardless of the engine's sort implementation.
      var sortedItems = [...byType.values()].map((item, index) => ({
        item,
        index
      })).sort((a, b) => {
        var _a$item$order, _b$item$order;
        return ((_a$item$order = a.item.order) !== null && _a$item$order !== void 0 ? _a$item$order : Infinity) - ((_b$item$order = b.item.order) !== null && _b$item$order !== void 0 ? _b$item$order : Infinity) || a.index - b.index;
      }).map(_ref => {
        var item = _ref.item;
        return item;
      });
      return Object.freeze(sortedItems);
    }, {
      max: 1
    }));
    _defineProperty(this, "getCachedHiddenColumns", memoize((metricCalculator, userColumnWidths) => IrisGridUtils.getHiddenColumns(new Map([...metricCalculator.initialColumnWidths, ...userColumnWidths])), {
      max: 1
    }));
    _defineProperty(this, "getCachedHiddenColumnNames", memoize((hiddenColumns, columns) => Object.freeze(hiddenColumns.map(idx => {
      var _columns$idx;
      return (_columns$idx = columns[idx]) === null || _columns$idx === void 0 ? void 0 : _columns$idx.name;
    }).filter(n => n != null)), {
      max: 1
    }));
    _defineProperty(this, "getCachedViewState", memoize(hiddenColumns => Object.freeze({
      hiddenColumns
    }), {
      max: 1
    }));
    _defineProperty(this, "getAggregationMap", memoize((columns, aggregations) => {
      var aggregationMap = {};
      aggregations.forEach(_ref2 => {
        var operation = _ref2.operation,
          selected = _ref2.selected,
          invert = _ref2.invert;
        aggregationMap[operation] = AggregationUtils.getOperationColumnNames(columns, operation, selected, invert);
      });
      return aggregationMap;
    }, {
      max: 1
    }));
    _defineProperty(this, "getOperationMap", memoize((columns, aggregations) => IrisGridUtils.getOperationMap(columns, aggregations), {
      max: 1
    }));
    _defineProperty(this, "getOperationOrder", memoize(aggregations => IrisGridUtils.getOperationOrder(aggregations), {
      max: 1
    }));
    _defineProperty(this, "getCachedFormatColumns", memoize((dh, columns, rules) => getFormatColumns(dh, columns, rules), {
      max: 1000
    }));
    /**
     * Builds formatColumns array based on the provided formatting rules with optional preview
     * @param columns Array of columns
     * @param rulesParam Array of formatting rules
     * @param preview Optional temporary formatting rule for previewing live changes
     * @param editIndex Index in the rulesParam array to replace with the preview, null if preview not applicable
     * @returns Format columns array
     */
    _defineProperty(this, "getCachedPreviewFormatColumns", memoize((dh, columns, rulesParam, preview, editIndex) => {
      log.debug('getCachedPreviewFormatColumns', rulesParam, preview, editIndex);
      if (preview !== undefined && editIndex !== undefined) {
        var rules = [...rulesParam];
        rules[editIndex] = preview;
        return this.getCachedFormatColumns(dh, columns, rules);
      }
      return this.getCachedFormatColumns(dh, columns, rulesParam);
    }, {
      max: 1
    }));
    _defineProperty(this, "getModelRollupConfig", memoize((originalColumns, config, aggregationSettings) => IrisGridUtils.getModelRollupConfig(originalColumns, config, aggregationSettings), {
      max: 1
    }));
    _defineProperty(this, "getModelTotalsConfig", memoize((columns, config, aggregationSettings) => IrisGridUtils.getModelTotalsConfig(columns, config, aggregationSettings), {
      max: 1
    }));
    _defineProperty(this, "getCachedStateOverride", memoize((model, theme, hoverSelectColumn, isFilterBarShown, isSelectingColumn, loadingScrimProgress, quickFilters, advancedFilters, sorts, reverse, rollupConfig, isMenuShown) => ({
      model,
      theme,
      hoverSelectColumn,
      isFilterBarShown,
      isSelectingColumn,
      loadingScrimProgress,
      quickFilters,
      advancedFilters,
      sorts,
      reverse,
      rollupConfig,
      isMenuShown
    }), {
      max: 1
    }));
    _defineProperty(this, "getCachedFilter", memoize((customFilters, quickFilters, advancedFilters, searchFilter) => [...(customFilters !== null && customFilters !== void 0 ? customFilters : []), ...IrisGridUtils.getFiltersFromFilterMap(quickFilters), ...IrisGridUtils.getFiltersFromFilterMap(advancedFilters), ...(searchFilter !== undefined ? [searchFilter] : [])], {
      max: 1
    }));
    _defineProperty(this, "getCachedTheme", memoize((contextTheme, theme, isEditable, floatingRowCount, density) => {
      var _theme$rowFooterWidth;
      // If a theme is available via context, use that as the base theme.
      // If iris-grid is standalone without a context, use the default theme.
      var baseTheme = contextTheme !== null && contextTheme !== void 0 ? contextTheme : createDefaultIrisGridTheme();

      // We only show the row footers when we have floating rows for aggregations
      var rowFooterWidth = floatingRowCount > 0 ? (_theme$rowFooterWidth = theme === null || theme === void 0 ? void 0 : theme.rowFooterWidth) !== null && _theme$rowFooterWidth !== void 0 ? _theme$rowFooterWidth : baseTheme.rowFooterWidth : 0;
      var metricCalculator = this.state.metricCalculator;
      if (metricCalculator != null) {
        metricCalculator.resetCalculatedColumnWidths();
        metricCalculator.resetCalculatedRowHeights();
      }
      var densityTheme = {};
      if (density === 'compact') {
        densityTheme = baseTheme.density.compact;
      } else if (density === 'spacious') {
        densityTheme = baseTheme.density.spacious;
      }
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseTheme), densityTheme), theme), {}, {
        autoSelectRow: !isEditable,
        rowFooterWidth
      });
    }, {
      max: 1
    }));
    _defineProperty(this, "getCachedKeyHandlers", memoize(keyHandlers => [...keyHandlers, ...this.keyHandlers].sort((a, b) => a.order - b.order), {
      max: 1
    }));
    _defineProperty(this, "getCachedMouseHandlers", memoize(mouseHandlersProp => [...mouseHandlersProp, ...this.mouseHandlers].map(handler => typeof handler === 'function' ? handler(this) : handler), {
      max: 1
    }));
    _defineProperty(this, "getCachedRenderer", memoize(rendererProp => rendererProp !== null && rendererProp !== void 0 ? rendererProp : new IrisGridRenderer(), {
      max: 1
    }));
    _defineProperty(this, "getAlwaysFetchColumns", memoize((alwaysFetchColumns, columns, movedColumns, floatingLeftColumnCount, floatingRightColumnCount, draggingRange) => {
      var floatingColumns = [];
      for (var i = 0; i < floatingLeftColumnCount; i += 1) {
        floatingColumns.push(columns[GridUtils.getModelIndex(i, movedColumns)].name);
      }
      for (var _i = 0; _i < floatingRightColumnCount; _i += 1) {
        floatingColumns.push(columns[GridUtils.getModelIndex(columns.length - 1 - _i, movedColumns)].name);
      }
      if (draggingRange) {
        for (var _i2 = draggingRange[0]; _i2 <= draggingRange[1]; _i2 += 1) {
          floatingColumns.push(columns[GridUtils.getModelIndex(_i2, movedColumns)].name);
        }
      }
      var columnSet = new Set([...alwaysFetchColumns, ...floatingColumns]);
      return Object.freeze([...columnSet]);
    }, {
      max: 1
    }));
    _defineProperty(this, "updateSearchFilter", debounce((searchValue, selectedSearchColumns, columns, invertSearchColumns) => {
      var model = this.props.model;
      var searchFilter = CrossColumnSearch.createSearchFilter(model.dh, searchValue, selectedSearchColumns, columns, invertSearchColumns);
      this.setState({
        searchFilter
      });
    }, SET_FILTER_DEBOUNCE));
    _defineProperty(this, "showViewportLoading", throttle(() => {
      var model = this.props.model;
      var loadingSpinnerShown = this.state.loadingSpinnerShown;
      if (model.isViewportPending && !loadingSpinnerShown) {
        // We only want to show the viewport loading if the viewport is still loading
        // and we're not already showing a loader for something else
        this.startLoading('Waiting for viewport...', {
          loadingCancelShown: false,
          loadingBlocksGrid: false
        });
      }
    }, VIEWPORT_LOADING_DELAY, {
      leading: false,
      trailing: true
    }));
    // Apply live changes; clear any previous preview error on each new update
    _defineProperty(this, "handleConditionalFormatEditorUpdate", debounce(conditionalFormatPreview => {
      this.setState({
        conditionalFormatPreview,
        conditionalFormatError: null
      });
    }, SET_CONDITIONAL_FORMAT_DEBOUNCE));
    _defineProperty(this, "handleDownloadProgressUpdate", throttle((tableDownloadProgress, tableDownloadEstimatedTime) => {
      var tableDownloadStatus = this.state.tableDownloadStatus;
      if (tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.DOWNLOADING) {
        this.setState({
          tableDownloadProgress,
          tableDownloadEstimatedTime
        });
      }
    }, UPDATE_DOWNLOAD_THROTTLE));
    _defineProperty(this, "getOverflowButtonTooltip", memoize(overflowButtonTooltipProps => {
      if (overflowButtonTooltipProps == null) {
        return null;
      }
      var wrapperStyle = _objectSpread(_objectSpread({
        position: 'absolute'
      }, overflowButtonTooltipProps), {}, {
        pointerEvents: 'none'
      });
      var popperOptions = {
        placement: 'left',
        modifiers: {
          flip: {
            behavior: ['left', 'right']
          }
        }
      };
      return /*#__PURE__*/_jsx("div", {
        style: wrapperStyle,
        children: /*#__PURE__*/_jsx(Tooltip, {
          options: popperOptions,
          ref: this.handleTooltipRef,
          children: "View full contents"
        }, Date.now())
      });
    }, {
      max: 1
    }));
    _defineProperty(this, "getExpandCellTooltip", memoize(expandCellTooltipProps => {
      if (expandCellTooltipProps == null) {
        return null;
      }
      var expandTooltipDisplayValue = this.state.expandTooltipDisplayValue;
      var model = this.props.model;
      var isExpandAllAvailable = isExpandableGridModel(model) && model.isExpandAllAvailable;
      var wrapperStyle = _objectSpread(_objectSpread({
        position: 'absolute'
      }, expandCellTooltipProps), {}, {
        pointerEvents: 'none'
      });
      var popperOptions = {
        placement: 'bottom-start'
      };
      return /*#__PURE__*/_jsx("div", {
        style: wrapperStyle,
        children: /*#__PURE__*/_jsx(Tooltip, {
          options: popperOptions,
          ref: this.handleTooltipRef,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              textAlign: 'left'
            },
            children: ["Click to ", expandTooltipDisplayValue, " row", isExpandAllAvailable && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("br", {}), ContextActionUtils.isMacPlatform() ? '⌘' : 'Ctrl+', "Click to expand row and all children"]
            })]
          })
        }, Date.now())
      });
    }, {
      max: 1
    }));
    _defineProperty(this, "getHoverTooltip", memoize(hoverTooltipProps => {
      if (hoverTooltipProps == null) {
        return null;
      }
      var hoverDisplayValue = this.state.hoverDisplayValue;
      var wrapperStyle = _objectSpread(_objectSpread({
        position: 'absolute'
      }, hoverTooltipProps), {}, {
        pointerEvents: 'none'
      });
      var popperOptions = {
        placement: 'bottom'
      };
      return /*#__PURE__*/_jsx("div", {
        style: wrapperStyle,
        children: /*#__PURE__*/_jsx(Tooltip, {
          options: popperOptions,
          ref: this.handleTooltipRef,
          children: /*#__PURE__*/_jsx("div", {
            className: "link-hover-tooltip",
            children: hoverDisplayValue
          })
        })
      });
    }, {
      max: 1
    }));
    _defineProperty(this, "handleGotoValueChanged", input => {
      this.setState({
        gotoValue: input,
        gotoValueManuallyChanged: true
      });
      this.debouncedSeekRow(input);
    });
    _defineProperty(this, "debouncedSeekRow", debounce(input => {
      this.seekRow(input);
    }, SEEK_ROW_DEBOUNCE));
    this.handleAdvancedFilterChange = this.handleAdvancedFilterChange.bind(this);
    this.handleAdvancedFilterSortChange = this.handleAdvancedFilterSortChange.bind(this);
    this.handleAdvancedFilterDone = this.handleAdvancedFilterDone.bind(this);
    this.handleAdvancedFilterToggleMaximize = this.handleAdvancedFilterToggleMaximize.bind(this);
    this.handleAdvancedMenuOpened = this.handleAdvancedMenuOpened.bind(this);
    this.handleGotoRowOpened = this.handleGotoRowOpened.bind(this);
    this.handleGotoRowClosed = this.handleGotoRowClosed.bind(this);
    this.handleAdvancedMenuClosed = this.handleAdvancedMenuClosed.bind(this);
    this.handleAggregationChange = this.handleAggregationChange.bind(this);
    this.handleAggregationsChange = this.handleAggregationsChange.bind(this);
    this.handleAggregationEdit = this.handleAggregationEdit.bind(this);
    this.handleAnimationLoop = this.handleAnimationLoop.bind(this);
    this.handleAnimationStart = this.handleAnimationStart.bind(this);
    this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
    this.handleChartChange = this.handleChartChange.bind(this);
    this.handleChartCreate = this.handleChartCreate.bind(this);
    this.handleGridError = this.handleGridError.bind(this);
    this.handleFilterBarChange = this.handleFilterBarChange.bind(this);
    this.handleFilterBarDone = this.handleFilterBarDone.bind(this);
    this.handleFilterBarTab = this.handleFilterBarTab.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleMenu = this.handleMenu.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleMenuSelect = this.handleMenuSelect.bind(this);
    this.handleMenuBack = this.handleMenuBack.bind(this);
    this.handleRequestFailed = this.handleRequestFailed.bind(this);
    this.handlePending = this.handlePending.bind(this);
    this.handlePendingCleared = this.handlePendingCleared.bind(this);
    this.handleSelectionChanged = this.handleSelectionChanged.bind(this);
    this.handleMovedColumnsChanged = this.handleMovedColumnsChanged.bind(this);
    this.handleHeaderGroupsChanged = this.handleHeaderGroupsChanged.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleTableChanged = this.handleTableChanged.bind(this);
    this.handleSchemaChanged = this.handleSchemaChanged.bind(this);
    this.handleTooltipRef = this.handleTooltipRef.bind(this);
    this.handleViewChanged = this.handleViewChanged.bind(this);
    this.handleFormatSelection = this.handleFormatSelection.bind(this);
    this.handleColumnAlignmentChange = this.handleColumnAlignmentChange.bind(this);
    this.handleConditionalFormatCreate = this.handleConditionalFormatCreate.bind(this);
    this.handleConditionalFormatEdit = this.handleConditionalFormatEdit.bind(this);
    this.handleConditionalFormatsChange = this.handleConditionalFormatsChange.bind(this);
    this.handleConditionalFormatEditorSave = this.handleConditionalFormatEditorSave.bind(this);
    this.handleConditionalFormatEditorCancel = this.handleConditionalFormatEditorCancel.bind(this);
    this.handleUpdateCustomColumns = this.handleUpdateCustomColumns.bind(this);
    this.handleCustomColumnsChanged = this.handleCustomColumnsChanged.bind(this);
    this.handleSelectDistinctChanged = this.handleSelectDistinctChanged.bind(this);
    this.handlePendingDataUpdated = this.handlePendingDataUpdated.bind(this);
    this.handleViewportUpdated = this.handleViewportUpdated.bind(this);
    this.handlePendingCommitClicked = this.handlePendingCommitClicked.bind(this);
    this.handlePendingDiscardClicked = this.handlePendingDiscardClicked.bind(this);
    this.handleGotoRowSelectedRowNumberSubmit = this.handleGotoRowSelectedRowNumberSubmit.bind(this);
    this.focusRowInGrid = this.focusRowInGrid.bind(this);
    this.handleDownloadTable = this.handleDownloadTable.bind(this);
    this.handleDownloadTableStart = this.handleDownloadTableStart.bind(this);
    this.handleCancelDownloadTable = this.handleCancelDownloadTable.bind(this);
    this.handleDownloadCanceled = this.handleDownloadCanceled.bind(this);
    this.handleDownloadCompleted = this.handleDownloadCompleted.bind(this);
    this.handlePartitionChange = this.handlePartitionChange.bind(this);
    this.handleColumnVisibilityChanged = this.handleColumnVisibilityChanged.bind(this);
    this.handleColumnVisibilityReset = this.handleColumnVisibilityReset.bind(this);
    this.handleCrossColumnSearch = this.handleCrossColumnSearch.bind(this);
    this.handleRollupChange = this.handleRollupChange.bind(this);
    this.handleOverflowClose = this.handleOverflowClose.bind(this);
    this.handleCloseNoPastePermissionModal = this.handleCloseNoPastePermissionModal.bind(this);
    this.getColumnBoundingRect = this.getColumnBoundingRect.bind(this);
    this.handleGotoRowSelectedRowNumberChanged = this.handleGotoRowSelectedRowNumberChanged.bind(this);
    this.handleGotoValueSelectedColumnNameChanged = this.handleGotoValueSelectedColumnNameChanged.bind(this);
    this.handleGotoValueSelectedFilterChanged = this.handleGotoValueSelectedFilterChanged.bind(this);
    this.handleGotoValueChanged = this.handleGotoValueChanged.bind(this);
    this.handleGotoValueSubmitted = this.handleGotoValueSubmitted.bind(this);
    this.handleViewportUpdated = this.handleViewportUpdated.bind(this);
    this.makeQuickFilter = this.makeQuickFilter.bind(this);
    this.setFilterMap = this.setFilterMap.bind(this);
    this.handleFrozenColumnsChanged = this.handleFrozenColumnsChanged.bind(this);
    this.grid = null;
    this.lastLoadedConfig = null;
    this.pending = new Pending();
    this.globalColumnFormats = EMPTY_ARRAY;
    this.decimalFormatOptions = {};
    this.integerFormatOptions = {};
    this.truncateNumbersWithPound = false;
    this.showEmptyStrings = true;
    this.showNullStrings = true;
    this.showExtraGroupColumn = true;

    // When the loading scrim started/when it should extend to the end of the screen.
    this.tableSaver = null;
    this.crossColumnRef = /*#__PURE__*/React.createRef();
    this.isAnimating = false;
    this.filterInputRef = /*#__PURE__*/React.createRef();
    this.gotoRowRef = /*#__PURE__*/React.createRef();
    this.isCopying = false;
    this.toggleFilterBarAction = {
      action: () => this.toggleFilterBar(),
      shortcut: SHORTCUTS.TABLE.TOGGLE_QUICK_FILTER
    };
    this.toggleSearchBarAction = {
      action: () => this.toggleSearchBar(),
      shortcut: SHORTCUTS.TABLE.TOGGLE_SEARCH
    };
    this.toggleGotoRowAction = {
      action: () => this.toggleGotoRow(),
      shortcut: SHORTCUTS.TABLE.GOTO_ROW
    };
    this.discardAction = {
      action: () => {
        var model = this.props.model;
        if (isEditableGridModel(model) && model.isEditable && model.pendingDataMap.size > 0) {
          this.discardPending().catch(log.error);
        }
      },
      shortcut: SHORTCUTS.INPUT_TABLE.DISCARD
    };
    this.commitAction = {
      action: () => {
        var model = this.props.model;
        if (isEditableGridModel(model) && model.isEditable && model.pendingDataMap.size > 0 && model.pendingDataErrors.size === 0) {
          this.commitPending().catch(log.error);
        }
      },
      shortcut: SHORTCUTS.INPUT_TABLE.COMMIT
    };
    this.contextActions = [this.toggleFilterBarAction, this.toggleSearchBarAction, this.toggleGotoRowAction, this.discardAction, this.commitAction];
    var _aggregationSettings = props.aggregationSettings,
      conditionalFormats = props.conditionalFormats,
      customColumnFormatMap = props.customColumnFormatMap,
      columnAlignmentMap = props.columnAlignmentMap,
      _isFilterBarShown = props.isFilterBarShown,
      isSelectingPartition = props.isSelectingPartition,
      partitions = props.partitions,
      partitionConfig = props.partitionConfig,
      _model = props.model,
      movedColumnsProp = props.movedColumns,
      movedRowsProp = props.movedRows,
      _rollupConfig = props.rollupConfig,
      _userColumnWidths = props.userColumnWidths,
      userColumnWidthsByName = props.userColumnWidthsByName,
      userRowHeights = props.userRowHeights,
      _showSearchBar = props.showSearchBar,
      _searchValue = props.searchValue,
      _selectedSearchColumns = props.selectedSearchColumns,
      _invertSearchColumns = props.invertSearchColumns,
      _advancedFilters = props.advancedFilters,
      _quickFilters = props.quickFilters,
      selectDistinctColumns = props.selectDistinctColumns,
      pendingDataMap = props.pendingDataMap,
      canCopy = props.canCopy,
      frozenColumns = props.frozenColumns,
      columnHeaderGroups = props.columnHeaderGroups,
      getMetricCalculator = props.getMetricCalculator;
    var _dh = _model.dh;
    var _keyHandlers = [new CopyCellKeyHandler(this), new ReverseKeyHandler(this), new ClearFilterKeyHandler(this)];
    var mouseHandlers = [new IrisGridCellOverflowMouseHandler(this), new IrisGridRowTreeMouseHandler(this), new IrisGridTokenMouseHandler(this), new IrisGridColumnSelectMouseHandler(this), new IrisGridColumnTooltipMouseHandler(this), new IrisGridSortMouseHandler(this), new IrisGridFilterMouseHandler(this), new IrisGridContextMenuHandler(this, _dh), new IrisGridDataSelectMouseHandler(this), new PendingMouseHandler(this), new IrisGridPartitionedTableMouseHandler(this), ...(canCopy ? [new IrisGridCopyCellMouseHandler(this)] : [])];
    if (canCopy) {
      _keyHandlers.push(new CopyKeyHandler(this));
    }
    var _movedColumns = movedColumnsProp.length > 0 ? movedColumnsProp : _model.initialMovedColumns;
    var movedRows = movedRowsProp.length > 0 ? movedRowsProp : _model.initialMovedRows;
    var _metricCalculator = getMetricCalculator({
      userColumnWidths: new Map(_userColumnWidths),
      userColumnWidthsByName: userColumnWidthsByName != null ? new Map(userColumnWidthsByName) : undefined,
      userRowHeights: new Map(userRowHeights),
      movedColumns: _movedColumns,
      initialColumnWidths: new Map(_model === null || _model === void 0 || (_model$layoutHints = _model.layoutHints) === null || _model$layoutHints === void 0 || (_model$layoutHints = _model$layoutHints.hiddenColumns) === null || _model$layoutHints === void 0 ? void 0 : _model$layoutHints.map(name => [_model.getColumnIndexByName(name), 0]))
    });
    // Remember the factory we used so `maybeRebuildMetricCalculator` (called
    // from `componentDidUpdate` when the `getMetricCalculator` prop changes)
    // can detect a model-driven swap, e.g. pivot-builder's proxy swapping its
    // inner model.
    this.lastMetricCalculatorFactory = getMetricCalculator;
    var searchColumns = _selectedSearchColumns !== null && _selectedSearchColumns !== void 0 ? _selectedSearchColumns : [];
    var _searchFilter = CrossColumnSearch.createSearchFilter(_dh, _searchValue, searchColumns, _model.columns, _invertSearchColumns);
    this.tableUtils = new TableUtils(_dh);
    this.mouseHandlers = mouseHandlers;
    this.keyHandlers = _keyHandlers;
    this.state = {
      isFilterBarShown: _isFilterBarShown,
      isSelectingPartition,
      focusedFilterBarColumn: null,
      metricCalculator: _metricCalculator,
      metrics: undefined,
      partitionConfig: partitionConfig !== null && partitionConfig !== void 0 ? partitionConfig : partitions && partitions.length ? {
        partitions,
        mode: 'partition'
      } : undefined,
      // setAdvancedFilter and setQuickFilter mutate the arguments
      // so we want to always use map copies from the state instead of props
      quickFilters: _quickFilters ? new Map(_quickFilters) : new Map(),
      advancedFilters: new Map(_advancedFilters),
      shownAdvancedFilter: null,
      maximizedAdvancedFilter: null,
      hoverAdvancedFilter: null,
      sorts: [],
      reverse: false,
      customColumns: [],
      selectDistinctColumns,
      // selected range in table
      selectedRanges: [],
      // Current ongoing copy operation
      copyOperation: null,
      // The filter that is currently being applied. Reset after update is received
      loadingText: null,
      loadingScrimProgress: null,
      loadingSpinnerShown: false,
      loadingCancelShown: false,
      loadingBlocksGrid: false,
      movedColumns: _movedColumns,
      movedRows,
      shownColumnTooltip: null,
      formatter: new Formatter(_dh),
      isMenuShown: false,
      customColumnFormatMap: new Map(customColumnFormatMap),
      columnAlignmentMap: new Map(columnAlignmentMap),
      conditionalFormats,
      conditionalFormatEditIndex: null,
      conditionalFormatPreview: undefined,
      conditionalFormatError: null,
      // Column user is hovering over for selection
      hoverSelectColumn: null,
      isTableDownloading: false,
      isReady: false,
      tableDownloadStatus: '',
      tableDownloadProgress: 0,
      tableDownloadEstimatedTime: 0,
      showSearchBar: _showSearchBar,
      searchFilter: _searchFilter,
      searchValue: _searchValue,
      selectedSearchColumns: searchColumns,
      invertSearchColumns: _invertSearchColumns,
      rollupConfig: _rollupConfig,
      rollupSelectedColumns: [],
      aggregationSettings:
      // Pin aggregations to the top if the grid is editable, so that the bottom is reserved for pending rows
      isEditableGridModel(_model) && _model.isEditable ? _objectSpread(_objectSpread({}, _aggregationSettings), {}, {
        showOnTop: true
      }) : _aggregationSettings,
      selectedAggregation: null,
      openOptions: [],
      pendingRowCount: 0,
      pendingDataMap: pendingDataMap !== null && pendingDataMap !== void 0 ? pendingDataMap : new Map(),
      pendingDataErrors: new Map(),
      pendingSavePromise: null,
      pendingSaveError: null,
      toastMessage: null,
      frozenColumns,
      showOverflowModal: false,
      showNoPastePermissionModal: false,
      noPastePermissionError: '',
      overflowText: '',
      overflowButtonTooltipProps: null,
      expandCellTooltipProps: null,
      expandTooltipDisplayValue: 'expand',
      hoverTooltipProps: null,
      hoverDisplayValue: '',
      isGotoShown: false,
      gotoRow: '',
      gotoRowError: '',
      gotoValueError: '',
      gotoValueSelectedColumnName: (_model$columns$0$name = (_model$columns$ = _model.columns[0]) === null || _model$columns$ === void 0 ? void 0 : _model$columns$.name) !== null && _model$columns$0$name !== void 0 ? _model$columns$0$name : '',
      gotoValueSelectedFilter: FilterType.eqIgnoreCase,
      gotoValue: '',
      gotoValueManuallyChanged: false,
      columnHeaderGroups: columnHeaderGroups !== null && columnHeaderGroups !== void 0 ? columnHeaderGroups : _model.initialColumnHeaderGroups
    };
  }
  componentDidMount() {
    var model = this.props.model;
    this.initState();
    this.startListening(model);
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$props = this.props,
      inputFilters = _this$props.inputFilters,
      isSelectingColumn = _this$props.isSelectingColumn,
      settings = _this$props.settings,
      model = _this$props.model,
      customFilters = _this$props.customFilters,
      quickFilters = _this$props.quickFilters,
      sorts = _this$props.sorts,
      isQuickFiltersControlled = _this$props.isQuickFiltersControlled,
      isSortsControlled = _this$props.isSortsControlled,
      getMetricCalculator = _this$props.getMetricCalculator;
    if (model !== prevProps.model) {
      this.stopListening(prevProps.model);
      this.startListening(model);
    }

    // The renderer and mouse handlers flow through memoized getters in
    // render(), so a `renderer` / `mouseHandlers` prop change naturally
    // propagates on the next render. The metric calculator, however, lives in
    // component state, so mirror that path when the `getMetricCalculator` prop
    // changes (e.g. the pivot-builder middleware swapping the pivot factory in
    // or out) so the calculator stays in sync. Moved columns are not touched
    // here — a model swap resets them via `handleSchemaChanged`.
    if (getMetricCalculator !== prevProps.getMetricCalculator) {
      this.maybeRebuildMetricCalculator();
    }
    var changedInputFilters = inputFilters !== prevProps.inputFilters ? inputFilters.filter(inputFilter => !prevProps.inputFilters.includes(inputFilter)) : [];
    if (changedInputFilters.length > 0) {
      var _advancedSettings$get;
      var advancedSettings = this.props.advancedSettings;
      var replaceExistingFilters = (_advancedSettings$get = advancedSettings.get(AdvancedSettingsType.FILTER_CONTROL_CHANGE_CLEARS_ALL_FILTERS)) !== null && _advancedSettings$get !== void 0 ? _advancedSettings$get : false;
      if (replaceExistingFilters) {
        this.clearGridInputField();
        this.clearCrossColumSearch();
      }
      var isChanged = this.applyInputFilters(changedInputFilters, replaceExistingFilters);
      if (isChanged) {
        this.startLoading('Filtering...', {
          resetRanges: true
        });
      }
    }
    if (isSelectingColumn !== prevProps.isSelectingColumn) {
      this.resetColumnSelection();
    }
    if (settings !== prevProps.settings) {
      this.updateFormatterSettings(settings);
    }
    if (customFilters !== prevProps.customFilters) {
      this.startLoading('Filtering...', {
        resetRanges: true
      });
    }
    if (sorts !== prevProps.sorts || !prevProps.isSortsControlled && isSortsControlled) {
      this.updateSorts(sorts);
    }
    if (quickFilters !== prevProps.quickFilters || !prevProps.isQuickFiltersControlled && isQuickFiltersControlled) {
      this.updateQuickFilters(quickFilters);
    }
    var loadingScrimStartTime = this.loadingScrimStartTime,
      loadingScrimFinishTime = this.loadingScrimFinishTime;
    if (loadingScrimStartTime != null && loadingScrimFinishTime != null) {
      window.requestAnimationFrame(() => {
        var now = Date.now();
        var currentTime = now - loadingScrimStartTime;
        var totalTime = loadingScrimFinishTime - loadingScrimStartTime;
        var loadingScrimProgress = Math.min(currentTime / totalTime, 1);
        if (loadingScrimFinishTime < now) {
          this.loadingScrimStartTime = undefined;
          this.loadingScrimFinishTime = undefined;
        }
        this.setState(state => {
          if (state.loadingScrimProgress == null) {
            log.debug2('Ignoring scrim update because loading cancelled.');
            return null;
          }
          return {
            loadingScrimProgress
          };
        });
      });
    }
    var openOptions = this.state.openOptions;
    if (openOptions !== prevState.openOptions) {
      var isAggEditType = option => option.type === OptionType.AGGREGATION_EDIT;
      if (!openOptions.some(isAggEditType) && prevState.openOptions.some(isAggEditType)) {
        this.removeEmptyAggregations();
      }
    }
    this.sendStateChange();
  }
  componentWillUnmount() {
    var model = this.props.model;
    this.stopListening(model);
    this.pending.cancel();
    this.updateSearchFilter.cancel();
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
    this.handleDownloadProgressUpdate.cancel();
    if (this.animationFrame !== undefined) {
      cancelAnimationFrame(this.animationFrame);
    }
    this.showViewportLoading.cancel();
  }
  get gridWrapper() {
    var _this$grid$canvasWrap, _this$grid;
    return (_this$grid$canvasWrap = (_this$grid = this.grid) === null || _this$grid === void 0 ? void 0 : _this$grid.canvasWrapper.current) !== null && _this$grid$canvasWrap !== void 0 ? _this$grid$canvasWrap : null;
  }
  getKeyHandlers() {
    var keyHandlers = this.props.keyHandlers;
    return this.getCachedKeyHandlers(keyHandlers);
  }
  getMetricState() {
    var _this$grid2;
    var gridMetricState = (_this$grid2 = this.grid) === null || _this$grid2 === void 0 ? void 0 : _this$grid2.getMetricState();
    if (gridMetricState == null) {
      return undefined;
    }
    var _this$state = this.state,
      advancedFilters = _this$state.advancedFilters,
      hoverSelectColumn = _this$state.hoverSelectColumn,
      isFilterBarShown = _this$state.isFilterBarShown,
      isMenuShown = _this$state.isMenuShown,
      loadingScrimProgress = _this$state.loadingScrimProgress,
      quickFilters = _this$state.quickFilters,
      sorts = _this$state.sorts,
      reverse = _this$state.reverse,
      rollupConfig = _this$state.rollupConfig;
    var _this$props2 = this.props,
      model = _this$props2.model,
      isSelectingColumn = _this$props2.isSelectingColumn;
    return _objectSpread(_objectSpread({}, gridMetricState), this.getCachedStateOverride(model, this.getTheme(), hoverSelectColumn, isFilterBarShown, isSelectingColumn, loadingScrimProgress, quickFilters, advancedFilters, sorts, reverse, rollupConfig, isMenuShown));
  }
  get renderer() {
    var renderer = this.props.renderer;
    return this.getCachedRenderer(renderer);
  }
  getMouseHandlers() {
    var mouseHandlers = this.props.mouseHandlers;
    return this.getCachedMouseHandlers(mouseHandlers);
  }
  getValueForCell(columnIndex, rowIndex) {
    var rawValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var model = this.props.model;
    var dh = model.dh;
    var modelColumn = this.getModelColumn(columnIndex);
    var modelRow = this.getModelRow(rowIndex);
    if (rawValue && modelColumn != null && modelRow != null) {
      var value = model.valueForCell(modelColumn, modelRow);
      if (TableUtils.isDateType(model.columns[modelColumn].type)) {
        // The returned value is just a long value, we should return the value formatted as a full date string
        var formatter = model.formatter;
        return dh.i18n.DateTimeFormat.format(UNFORMATTED_DATE_PATTERN, value, dh.i18n.TimeZone.getTimeZone(formatter.timeZone));
      }
      return value;
    }
    if (rawValue) {
      return null;
    }
    if (modelColumn != null && modelRow != null) {
      return model.textForCell(modelColumn, modelRow);
    }
    return '';
  }

  /**
   * Get the model column index for the provided visible index
   * @param columnIndex Visible column index
   * @returns Model column index, or null if not found
   */
  getModelColumn(columnIndex) {
    var metrics = this.state.metrics;
    assertNotNull(metrics);
    var modelColumns = metrics.modelColumns;
    if (modelColumns == null) {
      return null;
    }
    if (columnIndex != null && columnIndex < 0) {
      // ColumnBy sources aren't movable, so just return the index directly
      return columnIndex;
    }
    return columnIndex != null ? modelColumns.get(columnIndex) : null;
  }
  getModelRow(rowIndex) {
    var metrics = this.state.metrics;
    assertNotNull(metrics);
    var modelRows = metrics.modelRows;
    if (modelRows == null) {
      return null;
    }
    return rowIndex != null ? modelRows.get(rowIndex) : null;
  }
  getTheme() {
    var _ref3;
    var _this$props3 = this.props,
      model = _this$props3.model,
      theme = _this$props3.theme,
      density = _this$props3.density;
    var _this$context = this.context,
      contextTheme = _this$context.theme,
      contextDensity = _this$context.density;
    return this.getCachedTheme(contextTheme, theme, (_ref3 = isEditableGridModel(model) && model.isEditable) !== null && _ref3 !== void 0 ? _ref3 : false, model.floatingTopRowCount + model.floatingBottomRowCount, density !== null && density !== void 0 ? density : contextDensity);
  }
  getVisibleColumn(modelIndex) {
    var movedColumns = this.state.movedColumns;
    return GridUtils.getVisibleIndex(modelIndex, movedColumns);
  }
  makeQuickFilter(column, text, timeZone) {
    try {
      return this.tableUtils.makeQuickFilter(column, text, timeZone);
    } catch (err) {
      log.error('Error creating quick filter', err);
    }
    return null;
  }

  /**
   * Applies the provided input filters as quick filters,
   * and clears any existing quickFilters or advancedFilters on that column
   * @param inputFilters Array of input filters to apply
   * @param replaceExisting If true, new filters will replace the existing ones, instead of merging
   * @returns True if any filters were changed as a result of this operation
   */
  applyInputFilters(inputFilters) {
    var replaceExisting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var model = this.props.model;
    var _this$state2 = this.state,
      advancedFilters = _this$state2.advancedFilters,
      quickFilters = _this$state2.quickFilters;
    var newAdvancedFilters = replaceExisting ? new Map() : new Map(advancedFilters);
    var newQuickFilters = replaceExisting ? new Map() : new Map(quickFilters);
    var didAdvancedFiltersChange = replaceExisting && advancedFilters.size > 0;
    var didQuickFiltersChange = replaceExisting && quickFilters.size > 0;
    inputFilters.forEach(_ref4 => {
      var name = _ref4.name,
        type = _ref4.type,
        value = _ref4.value;
      var modelIndex = model.columns.findIndex(_ref5 => {
        var columnName = _ref5.name,
          columnType = _ref5.type;
        return columnName === name && columnType === type;
      });
      if (modelIndex >= 0) {
        didAdvancedFiltersChange = newAdvancedFilters.delete(modelIndex) || didAdvancedFiltersChange;
        didQuickFiltersChange = this.applyQuickFilter(modelIndex, value, newQuickFilters) || didQuickFiltersChange;
      } else {
        log.error('Unable to find column for inputFilter', name, type, value);
      }
    });
    if (didQuickFiltersChange) {
      this.requestQuickFiltersChange(newQuickFilters);
    }
    if (didAdvancedFiltersChange) {
      this.setState({
        advancedFilters: newAdvancedFilters
      });
    }
    return didQuickFiltersChange || didAdvancedFiltersChange;
  }

  /**
   * Applies a quick filter
   * @param modelIndex The index in the model of the column to set
   * @param value The string value to set to the quick filter
   * @param quickFilters The quick filters map
   * @returns True if the filters have changed because this quick filter was applied
   */
  applyQuickFilter(modelIndex, value, quickFilters) {
    var model = this.props.model;
    var formatter = model.formatter;
    var column = model.columns[modelIndex];
    if (value != null && "".concat(value).trim().length > 0) {
      var quickFilter = quickFilters.get(modelIndex);
      if (quickFilter != null) {
        var text = quickFilter.text;
        if (text === value) {
          log.debug2('Ignoring change to existing filter');
          return false;
        }
      }
      quickFilters.set(modelIndex, {
        text: value,
        filter: this.makeQuickFilter(column, value, formatter.timeZone)
      });
      return true;
    }
    return quickFilters.delete(modelIndex);
  }
  setAdvancedFilterMap(advancedFilters) {
    this.setState({
      advancedFilters
    });
  }
  setAdvancedFilter(modelIndex, filter, options) {
    log.debug('Setting advanced filter', modelIndex, filter);
    this.startLoading('Filtering...', {
      resetRanges: true
    });
    this.setState(_ref6 => {
      var advancedFilters = _ref6.advancedFilters;
      var newAdvancedFilters = new Map(advancedFilters);
      if (filter == null) {
        newAdvancedFilters.delete(modelIndex);
      } else {
        newAdvancedFilters.set(modelIndex, {
          filter,
          options
        });
      }
      return {
        advancedFilters: newAdvancedFilters
      };
    });
  }

  /**
   * Sets a quick filter against the provided column
   * @param modelIndex The index in the model for the column this filter is applied to
   * @param filter A filter to apply to the column, or null if there was an error
   * @param text The original text the filter was created with
   */
  setQuickFilter(modelIndex, filter, text) {
    log.debug('Setting quick filter', modelIndex, filter, text);
    var quickFilters = this.state.quickFilters;
    var newQuickFilters = new Map(quickFilters);
    newQuickFilters.set(modelIndex, {
      filter,
      text
    });
    this.requestQuickFiltersChange(newQuickFilters);
  }

  /**
   * Set grid filters based on the filter map
   * @param filterMap Filter map
   */
  setFilterMap(filterMap) {
    var _advancedSettings$get2;
    log.debug('setFilterMap', filterMap);
    var advancedSettings = this.props.advancedSettings;
    var clearFiltersOnLinkerFilterUpdate = (_advancedSettings$get2 = advancedSettings.get(AdvancedSettingsType.LINK_CHANGE_CLEARS_ALL_FILTERS)) !== null && _advancedSettings$get2 !== void 0 ? _advancedSettings$get2 : false;
    if (clearFiltersOnLinkerFilterUpdate) {
      this.clearAllFilters();
    }
    var model = this.props.model;
    var quickFilters = this.state.quickFilters;
    var newQuickFilters = clearFiltersOnLinkerFilterUpdate ? new Map() : new Map(quickFilters);
    var didQuickFiltersChange = false;
    filterMap.forEach((_ref7, columnName) => {
      var columnType = _ref7.columnType,
        filterList = _ref7.filterList;
      var column = model.columns.find(c => c.name === columnName && c.type === columnType);
      if (column == null) {
        return;
      }
      var columnIndex = model.getColumnIndexByName(column.name);
      assertNotNull(columnIndex);
      var combinedText = IrisGridUtils.combineFiltersFromList(columnType, filterList);
      if (combinedText.length === 0) {
        didQuickFiltersChange = newQuickFilters.delete(columnIndex) || didQuickFiltersChange;
      } else {
        var formatter = model.formatter;
        newQuickFilters.set(columnIndex, {
          filter: this.makeQuickFilter(column, combinedText, formatter.timeZone),
          text: "".concat(combinedText)
        });
        didQuickFiltersChange = true;
      }
    });
    if (didQuickFiltersChange) {
      this.requestQuickFiltersChange(newQuickFilters);
    }
  }
  removeColumnFilter(modelRange) {
    var clearRange = Array.isArray(modelRange) ? modelRange : [modelRange, modelRange];
    var _this$state3 = this.state,
      advancedFilters = _this$state3.advancedFilters,
      quickFilters = _this$state3.quickFilters;
    var isQuickFiltersControlled = this.props.isQuickFiltersControlled;
    var newAdvancedFilters = new Map(advancedFilters);
    var newQuickFilters = new Map(quickFilters);
    newAdvancedFilters.forEach((_, column) => {
      if (column >= clearRange[0] && column <= clearRange[1]) {
        newAdvancedFilters.delete(column);
      }
    });
    newQuickFilters.forEach((_, column) => {
      if (column >= clearRange[0] && column <= clearRange[1]) {
        newQuickFilters.delete(column);
      }
    });
    var didAdvancedFiltersChange = newAdvancedFilters.size !== advancedFilters.size;
    var didQuickFiltersChange = newQuickFilters.size !== quickFilters.size;
    if (didQuickFiltersChange) {
      this.requestQuickFiltersChange(newQuickFilters);
    }
    if (didAdvancedFiltersChange) {
      if (!didQuickFiltersChange || isQuickFiltersControlled) {
        this.startLoading('Filtering...', {
          resetRanges: true
        });
      }
      this.setState({
        advancedFilters: newAdvancedFilters
      });
    }
  }
  removeQuickFilter(modelColumn) {
    var quickFilters = this.state.quickFilters;
    var newQuickFilters = new Map(quickFilters);
    newQuickFilters.delete(modelColumn);
    this.requestQuickFiltersChange(newQuickFilters);
  }
  clearAllFilters() {
    log.debug('Clearing all filters');
    var _this$state4 = this.state,
      advancedFilters = _this$state4.advancedFilters,
      quickFilters = _this$state4.quickFilters,
      searchFilter = _this$state4.searchFilter;
    var isQuickFiltersControlled = this.props.isQuickFiltersControlled;
    if (quickFilters.size === 0 && advancedFilters.size === 0 && searchFilter === null) {
      return;
    }
    if (quickFilters.size > 0) {
      this.requestQuickFiltersChange(EMPTY_MAP);
    }
    var hasOtherFilters = advancedFilters.size > 0 || searchFilter != null;
    if (hasOtherFilters) {
      if (quickFilters.size === 0 || isQuickFiltersControlled) {
        this.startLoading('Clearing Filters...', {
          resetRanges: true
        });
      }
      this.setState({
        advancedFilters: new Map(),
        searchValue: '',
        searchFilter: undefined
      });
    }
    if (!isQuickFiltersControlled) {
      this.clearGridInputField();
    }
  }
  clearAllAggregations() {
    log.debug('Clearing all aggregations');
    this.setState({
      aggregationSettings: DEFAULT_AGGREGATION_SETTINGS
    });
  }
  clearCrossColumSearch() {
    log.debug('Clearing cross-column search');
    this.setState({
      searchValue: '',
      searchFilter: undefined
    });
  }
  clearGridInputField() {
    if (this.filterInputRef.current != null) {
      this.filterInputRef.current.setValue('');
    }
  }

  /**
   * Rebuilds all the current filters. Necessary if something like the time zone has changed.
   */
  rebuildFilters() {
    var model = this.props.model;
    var _this$state5 = this.state,
      advancedFilters = _this$state5.advancedFilters,
      quickFilters = _this$state5.quickFilters;
    if (advancedFilters.size === 0 && quickFilters.size === 0) {
      log.debug('No filters to rebuild');
      return;
    }
    var columns = model.columns,
      formatter = model.formatter;
    log.debug('Rebuilding filters');
    var newAdvancedFilters = new Map();
    var newQuickFilters = new Map();
    advancedFilters.forEach((value, key) => {
      var options = value.options;
      var column = columns[key];
      var filter = this.tableUtils.makeAdvancedFilter(column, options, formatter.timeZone);
      newAdvancedFilters.set(key, {
        options,
        filter
      });
    });
    quickFilters.forEach((value, key) => {
      var text = value.text;
      var column = columns[key];
      newQuickFilters.set(key, {
        text,
        filter: this.makeQuickFilter(column, text, formatter.timeZone)
      });
    });
    this.startLoading('Rebuilding filters...', {
      resetRanges: true
    });
    if (quickFilters.size > 0) {
      this.requestQuickFiltersChange(newQuickFilters);
    }
    this.setState({
      advancedFilters: newAdvancedFilters
    });
  }
  setFilters(_ref8) {
    var quickFilters = _ref8.quickFilters,
      advancedFilters = _ref8.advancedFilters;
    this.requestQuickFiltersChange(quickFilters);
    this.setState({
      advancedFilters
    });
  }
  updateFormatterSettings(settings) {
    var _settings$defaultDeci, _settings$defaultInte, _settings$truncateNum, _settings$showEmptySt, _settings$showNullStr, _settings$showExtraGr;
    var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var globalColumnFormats = FormatterUtils.getColumnFormats(settings);
    var dateTimeFormatterOptions = FormatterUtils.getDateTimeFormatterOptions(settings);
    var defaultDecimalFormatOptions = (_settings$defaultDeci = settings === null || settings === void 0 ? void 0 : settings.defaultDecimalFormatOptions) !== null && _settings$defaultDeci !== void 0 ? _settings$defaultDeci : {};
    var defaultIntegerFormatOptions = (_settings$defaultInte = settings === null || settings === void 0 ? void 0 : settings.defaultIntegerFormatOptions) !== null && _settings$defaultInte !== void 0 ? _settings$defaultInte : {};
    var truncateNumbersWithPound = (_settings$truncateNum = settings === null || settings === void 0 ? void 0 : settings.truncateNumbersWithPound) !== null && _settings$truncateNum !== void 0 ? _settings$truncateNum : false;
    var showEmptyStrings = (_settings$showEmptySt = settings === null || settings === void 0 ? void 0 : settings.showEmptyStrings) !== null && _settings$showEmptySt !== void 0 ? _settings$showEmptySt : true;
    var showNullStrings = (_settings$showNullStr = settings === null || settings === void 0 ? void 0 : settings.showNullStrings) !== null && _settings$showNullStr !== void 0 ? _settings$showNullStr : true;
    var showExtraGroupColumn = (_settings$showExtraGr = settings === null || settings === void 0 ? void 0 : settings.showExtraGroupColumn) !== null && _settings$showExtraGr !== void 0 ? _settings$showExtraGr : true;
    var isColumnFormatChanged = !deepEqual(this.globalColumnFormats, globalColumnFormats);
    var isDateFormattingChanged = !deepEqual(this.dateTimeFormatterOptions, dateTimeFormatterOptions);
    var isDecimalFormattingChanged = !deepEqual(this.decimalFormatOptions, settings === null || settings === void 0 ? void 0 : settings.defaultDecimalFormatOptions);
    var isIntegerFormattingChanged = !deepEqual(this.integerFormatOptions, defaultIntegerFormatOptions);
    var isTruncateNumbersChanged = this.truncateNumbersWithPound !== truncateNumbersWithPound;
    var isShowEmptyStringsChanged = this.showEmptyStrings !== showEmptyStrings;
    var isShowNullStringsChanged = this.showNullStrings !== showNullStrings;
    var isShowExtraGroupColumnChanged = this.showExtraGroupColumn !== showExtraGroupColumn;
    if (isColumnFormatChanged || isDateFormattingChanged || isDecimalFormattingChanged || isIntegerFormattingChanged || isTruncateNumbersChanged || isShowEmptyStringsChanged || isShowNullStringsChanged || isShowExtraGroupColumnChanged) {
      this.globalColumnFormats = globalColumnFormats;
      this.dateTimeFormatterOptions = dateTimeFormatterOptions;
      this.decimalFormatOptions = defaultDecimalFormatOptions;
      this.integerFormatOptions = defaultIntegerFormatOptions;
      this.truncateNumbersWithPound = truncateNumbersWithPound;
      this.showEmptyStrings = showEmptyStrings;
      this.showNullStrings = showNullStrings;
      this.showExtraGroupColumn = showExtraGroupColumn;
      this.updateFormatter({}, forceUpdate);
      if (isDateFormattingChanged && forceUpdate) {
        this.rebuildFilters();
      }
    }
  }
  updateFormatter(updatedFormats) {
    var _this$globalColumnFor;
    var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var customColumnFormatMap = this.state.customColumnFormatMap;
    var model = this.props.model;
    var update = _objectSpread({
      customColumnFormatMap
    }, updatedFormats);
    var mergedColumnFormats = [...((_this$globalColumnFor = this.globalColumnFormats) !== null && _this$globalColumnFor !== void 0 ? _this$globalColumnFor : []), ...update.customColumnFormatMap.values()];
    var formatter = new Formatter(model.dh, mergedColumnFormats, this.dateTimeFormatterOptions, this.decimalFormatOptions, this.integerFormatOptions, this.truncateNumbersWithPound, this.showEmptyStrings, this.showNullStrings);
    log.debug('updateFormatter', this.globalColumnFormats, mergedColumnFormats);
    this.setState(_objectSpread(_objectSpread({}, update), {}, {
      formatter
    }), () => {
      if (forceUpdate && this.grid) {
        this.grid.forceUpdate();
      }
    });
  }
  initFormatter() {
    var settings = this.props.settings;
    this.updateFormatterSettings(settings);
  }
  initState() {
    var model = this.props.model;
    try {
      if (isPartitionedGridModel(model) && model.isPartitionRequired) {
        this.loadPartitionsTable(model);
      } else {
        this.loadTableState();
      }
    } catch (error) {
      this.handleTableLoadError(error);
    }
  }
  loadTableState() {
    var _this$props4 = this.props,
      applyInputFiltersOnInit = _this$props4.applyInputFiltersOnInit,
      inputFilters = _this$props4.inputFilters,
      sorts = _this$props4.sorts,
      model = _this$props4.model,
      reverse = _this$props4.reverse,
      reverseType = _this$props4.reverseType,
      customColumns = _this$props4.customColumns,
      searchValue = _this$props4.searchValue,
      selectedSearchColumns = _this$props4.selectedSearchColumns,
      invertSearchColumns = _this$props4.invertSearchColumns;
    var searchColumns = selectedSearchColumns !== null && selectedSearchColumns !== void 0 ? selectedSearchColumns : [];
    var searchFilter = CrossColumnSearch.createSearchFilter(model.dh, searchValue, searchColumns, model.columns, invertSearchColumns);
    if (applyInputFiltersOnInit) {
      // There may be more than one input filter on the same column with value === '' applied last
      // We don't want to skip it here, so only excluding the ones that were never applied (null)
      var inputFiltersWithValues = inputFilters.filter(inputFilter => inputFilter.value != null);
      this.applyInputFilters(inputFiltersWithValues);
    }
    this.setState({
      sorts,
      reverse: reverse || reverseType === TableUtils.REVERSE_TYPE.POST_SORT,
      customColumns,
      isReady: true,
      searchFilter
    });
    this.initFormatter();
  }
  loadPartitionsTable(model) {
    var _this = this;
    return _asyncToGenerator(function* () {
      try {
        var partitionConfig = _this.state.partitionConfig;
        if (!partitionConfig) {
          _this.startLoading('Loading partitions...', {
            loadingCancelShown: false,
            resetRanges: true
          });
          _this.initializePartitionConfig(model);
        }
        _this.setState({
          isSelectingPartition: true
        }, _this.loadTableState);
      } catch (error) {
        if (!PromiseUtils.isCanceled(error)) {
          _this.handleTableLoadError(error);
        }
      }
    })();
  }

  /**
   * Initialize the partition config to the default partition.
   */
  initializePartitionConfig(model) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var keyTable = yield _this2.pending.add(model.partitionKeysTable(), resolved => resolved.close());
      var dh = model.dh;
      var sorts = keyTable.columns.map(column => column.sort().desc());
      keyTable.applySort(sorts);
      keyTable.setViewport(0, 0);

      // We want to wait for the first UPDATED event instead of just getting viewport data here
      // It's possible that the key table does not have any rows of data yet, so just wait until it does have one
      keyTable.addEventListener(dh.Table.EVENT_UPDATED, event => {
        try {
          var data = event.detail;
          if (data.rows.length === 0) {
            // We received an update and the table is still empty. Stop showing the loading spinner so we know
            _this2.stopLoading();
            return;
          }
          var row = data.rows[0];
          var values = keyTable.columns.map(column => row.get(column));
          var newPartition = {
            partitions: values,
            mode: model.isPartitionAwareSourceTable ? 'partition' : 'keys'
          };
          keyTable.close();
          _this2.setState({
            loadingSpinnerShown: false,
            partitionConfig: newPartition
          });
        } catch (e) {
          keyTable.close();
          log.error('Error getting initial partition config', e);
        }
      });
    })();
  }

  /**
   * Selects a partition key from the table based on the provided row index.
   *
   * @param rowIndex The index of the row from which the partition will be selected.
   * @returns A promise that resolves when the partition key has been successfully selected.
   */
  selectPartitionKeyFromTable(rowIndex) {
    var model = this.props.model;
    assertNotNull(rowIndex);
    if (isPartitionedGridModel(model)) {
      var data = this.getRowDataMap(rowIndex);
      var partitionColumnSet = new Set(model.partitionColumns.map(column => column.name));
      var values = Object.entries(data).filter(_ref9 => {
        var _ref0 = _slicedToArray(_ref9, 2),
          key = _ref0[0],
          _ = _ref0[1];
        return partitionColumnSet.has(key);
      }).map(_ref1 => {
        var _ref10 = _slicedToArray(_ref1, 2),
          key = _ref10[0],
          columnData = _ref10[1];
        return columnData.value;
      });
      var newPartition = {
        partitions: values,
        mode: 'partition'
      };
      this.setState({
        isSelectingPartition: true,
        partitionConfig: newPartition
      });
    }
  }
  copyCell(columnIndex, rowIndex) {
    var rawValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var canCopy = this.props.canCopy;
    if (canCopy) {
      var value = String(this.getValueForCell(columnIndex, rowIndex, rawValue));
      copyToClipboard(value).catch(e => log.error('Unable to copy cell', e));
    } else {
      log.error('Attempted to copyCell for user without copy permission.');
    }
  }
  copyColumnHeader(columnIndex) {
    var columnDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (columnIndex === null) {
      return;
    }
    var canCopy = this.props.canCopy;
    var movedColumns = this.state.movedColumns;
    if (canCopy) {
      var copyOperation = {
        columnIndex,
        columnDepth,
        movedColumns
      };
      this.setState({
        copyOperation
      });
    } else {
      log.error('Attempted copyColumnHeader for user without copy permission.');
    }
  }

  /**
   * Copy the provided ranges to the clipboard
   * @paramranges The ranges to copy
   * @param includeHeaders Include the headers or not
   * @param formatValues Whether to format values or not
   * @param error Error message if one occurred
   */
  copyRanges(ranges) {
    var includeHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var formatValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var error = arguments.length > 3 ? arguments[3] : undefined;
    var _this$props5 = this.props,
      model = _this$props5.model,
      canCopy = _this$props5.canCopy;
    var _this$state6 = this.state,
      metricCalculator = _this$state6.metricCalculator,
      movedColumns = _this$state6.movedColumns;
    var userColumnWidths = metricCalculator.getUserColumnWidths();
    if (canCopy) {
      var copyOperation = {
        ranges: GridRange.boundedRanges(ranges, model.columnCount, model.rowCount),
        includeHeaders,
        formatValues,
        movedColumns,
        userColumnWidths,
        error
      };
      this.setState({
        copyOperation
      });
    } else {
      log.error('Attempted copyRanges for user without copy permission.');
    }
  }
  startLoading(loadingText) {
    var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref11$resetRanges = _ref11.resetRanges,
      resetRanges = _ref11$resetRanges === void 0 ? false : _ref11$resetRanges,
      _ref11$loadingCancelS = _ref11.loadingCancelShown,
      loadingCancelShown = _ref11$loadingCancelS === void 0 ? true : _ref11$loadingCancelS,
      _ref11$loadingBlocksG = _ref11.loadingBlocksGrid,
      loadingBlocksGrid = _ref11$loadingBlocksG === void 0 ? true : _ref11$loadingBlocksG;
    this.setState({
      loadingText,
      loadingCancelShown,
      loadingBlocksGrid
    });
    var theme = this.getTheme();
    if (resetRanges && this.grid) {
      this.grid.clearSelectedRanges();
      this.grid.setViewState({
        top: 0
      }, true);
    }
    if (this.loadingScrimStartTime == null) {
      var _this$gridWrapper$get, _this$gridWrapper;
      var minScrimTransitionTime = theme.minScrimTransitionTime,
        maxScrimTransitionTime = theme.maxScrimTransitionTime;
      assertNotNull(minScrimTransitionTime);
      assertNotNull(maxScrimTransitionTime);
      var height = (_this$gridWrapper$get = (_this$gridWrapper = this.gridWrapper) === null || _this$gridWrapper === void 0 ? void 0 : _this$gridWrapper.getBoundingClientRect().height) !== null && _this$gridWrapper$get !== void 0 ? _this$gridWrapper$get : 0;
      var scrimTransitionTime = Math.max(minScrimTransitionTime, Math.min(height / 2, maxScrimTransitionTime));
      this.loadingScrimStartTime = Date.now();
      this.loadingScrimFinishTime = this.loadingScrimStartTime + scrimTransitionTime;
      this.setState({
        loadingScrimProgress: 0
      });
      this.loadingTimer = setTimeout(() => {
        this.setState({
          loadingSpinnerShown: true
        });
      }, IrisGrid.loadingSpinnerDelay);
    }
  }
  stopLoading() {
    this.showViewportLoading.cancel();
    this.loadingScrimStartTime = undefined;
    this.loadingScrimFinishTime = undefined;
    this.setState({
      loadingText: null,
      loadingScrimProgress: null,
      loadingSpinnerShown: false,
      loadingCancelShown: false
    });
    if (this.loadingTimer != null) {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = undefined;
    }
  }

  /**
   * Rolls back the table state to the last known safe state, or if that's not available then clears all sorts/filters/custom columns.
   */
  rollback() {
    if (this.lastLoadedConfig) {
      log.debug('loading last loading config', this.lastLoadedConfig);
      var _this$lastLoadedConfi = this.lastLoadedConfig,
        advancedFilters = _this$lastLoadedConfi.advancedFilters,
        aggregationSettings = _this$lastLoadedConfi.aggregationSettings,
        conditionalFormats = _this$lastLoadedConfi.conditionalFormats,
        conditionalFormatEditIndex = _this$lastLoadedConfi.conditionalFormatEditIndex,
        conditionalFormatPreview = _this$lastLoadedConfi.conditionalFormatPreview,
        customColumns = _this$lastLoadedConfi.customColumns,
        quickFilters = _this$lastLoadedConfi.quickFilters,
        reverse = _this$lastLoadedConfi.reverse,
        rollupConfig = _this$lastLoadedConfi.rollupConfig,
        searchFilter = _this$lastLoadedConfi.searchFilter,
        selectDistinctColumns = _this$lastLoadedConfi.selectDistinctColumns,
        sorts = _this$lastLoadedConfi.sorts;
      this.lastLoadedConfig = null;
      this.setState({
        advancedFilters,
        aggregationSettings,
        conditionalFormats,
        conditionalFormatEditIndex,
        conditionalFormatPreview,
        customColumns,
        quickFilters,
        reverse,
        rollupConfig,
        searchFilter,
        selectDistinctColumns,
        sorts
      });
    } else {
      log.debug('remove all sorts, filters, and custom columns');
      this.setState({
        advancedFilters: new Map(),
        aggregationSettings: DEFAULT_AGGREGATION_SETTINGS,
        conditionalFormats: [],
        conditionalFormatEditIndex: null,
        conditionalFormatPreview: undefined,
        customColumns: [],
        quickFilters: new Map(),
        reverse: false,
        rollupConfig: undefined,
        selectDistinctColumns: [],
        sorts: []
      });
    }
  }

  /**
   * Check if we can rollback the current state to a safe state.
   * @returns true if there's a previously known safe state or if some of the current state isn't empty.
   */
  canRollback() {
    return this.lastLoadedConfig != null || !IrisGridUtils.isEmptyConfig(this.state);
  }
  startListening(model) {
    model.addEventListener(IrisGridModel.EVENT.UPDATED, this.handleUpdate);
    model.addEventListener(IrisGridModel.EVENT.REQUEST_FAILED, this.handleRequestFailed);
    model.addEventListener(IrisGridModel.EVENT.PENDING, this.handlePending);
    model.addEventListener(IrisGridModel.EVENT.PENDING_CLEARED, this.handlePendingCleared);
    model.addEventListener(IrisGridModel.EVENT.COLUMNS_CHANGED, this.handleCustomColumnsChanged);
    model.addEventListener(IrisGridModel.EVENT.PENDING_DATA_UPDATED, this.handlePendingDataUpdated);
    model.addEventListener(IrisGridModel.EVENT.VIEWPORT_UPDATED, this.handleViewportUpdated);
    model.addEventListener(IrisGridModel.EVENT.TABLE_CHANGED, this.handleTableChanged);
    model.addEventListener(IrisGridModel.EVENT.SCHEMA_CHANGED, this.handleSchemaChanged);
  }
  stopListening(model) {
    model.removeEventListener(IrisGridModel.EVENT.UPDATED, this.handleUpdate);
    model.removeEventListener(IrisGridModel.EVENT.REQUEST_FAILED, this.handleRequestFailed);
    model.removeEventListener(IrisGridModel.EVENT.PENDING, this.handlePending);
    model.removeEventListener(IrisGridModel.EVENT.PENDING_CLEARED, this.handlePendingCleared);
    model.removeEventListener(IrisGridModel.EVENT.COLUMNS_CHANGED, this.handleCustomColumnsChanged);
    model.removeEventListener(IrisGridModel.EVENT.PENDING_DATA_UPDATED, this.handlePendingDataUpdated);
    model.removeEventListener(IrisGridModel.EVENT.VIEWPORT_UPDATED, this.handleViewportUpdated);
    model.removeEventListener(IrisGridModel.EVENT.TABLE_CHANGED, this.handleTableChanged);
    model.removeEventListener(IrisGridModel.EVENT.SCHEMA_CHANGED, this.handleSchemaChanged);
  }
  focus() {
    var _this$grid3;
    (_this$grid3 = this.grid) === null || _this$grid3 === void 0 || _this$grid3.focus();
  }
  focusFilterBar(column) {
    var movedColumns = this.state.movedColumns;
    var model = this.props.model;
    var columnCount = model.columnCount;
    var modelColumn = GridUtils.getModelIndex(column, movedColumns);
    if (column == null || columnCount <= column || !model.isFilterable(modelColumn)) {
      this.setState({
        focusedFilterBarColumn: null
      });
      return;
    }
    var _this$state7 = this.state,
      metricCalculator = _this$state7.metricCalculator,
      metrics = _this$state7.metrics;
    assertNotNull(metrics);
    var metricState = this.getMetricState();
    assertNotNull(metricState);
    var scrollColumn = metricCalculator.getScrollLeftForColumn(column, metricState, metrics);
    if (scrollColumn != null) {
      var _this$grid4;
      (_this$grid4 = this.grid) === null || _this$grid4 === void 0 || _this$grid4.setViewState({
        left: scrollColumn,
        leftOffset: 0
      }, true);
    }
    this.lastFocusedFilterBarColumn = column;
    this.setState({
      focusedFilterBarColumn: column,
      isFilterBarShown: true
    });
  }
  hideColumnByVisibleIndex(columnVisibleIndex) {
    var _this$grid5;
    var _this$state8 = this.state,
      metricCalculator = _this$state8.metricCalculator,
      movedColumns = _this$state8.movedColumns;
    metricCalculator.setColumnWidth(GridUtils.getModelIndex(columnVisibleIndex, movedColumns), 0);
    (_this$grid5 = this.grid) === null || _this$grid5 === void 0 || _this$grid5.forceUpdate();
  }
  freezeColumnByColumnName(columnName) {
    var _this$state9 = this.state,
      frozenColumns = _this$state9.frozenColumns,
      movedColumns = _this$state9.movedColumns;
    var model = this.props.model;
    log.debug2('freezing column', columnName);
    var allFrozenColumns = frozenColumns == null ? new Set(model.frozenColumns) : new Set(frozenColumns);
    allFrozenColumns.add(columnName);
    var modelIndex = model.getColumnIndexByName(columnName);
    assertNotNull(modelIndex);
    var visibleIndex = GridUtils.getVisibleIndex(modelIndex, movedColumns);
    var newMovedColumns = GridUtils.moveItem(visibleIndex, allFrozenColumns.size - 1, movedColumns);
    this.setState({
      frozenColumns: [...allFrozenColumns],
      movedColumns: newMovedColumns
    });
  }
  unFreezeColumnByColumnName(columnName) {
    var _this$state0 = this.state,
      frozenColumns = _this$state0.frozenColumns,
      movedColumns = _this$state0.movedColumns;
    var model = this.props.model;
    log.debug2('unfreezing column', columnName);
    var allFrozenColumns = frozenColumns == null ? new Set(model.frozenColumns) : new Set(frozenColumns);
    allFrozenColumns.delete(columnName);
    var modelIndex = model.getColumnIndexByName(columnName);
    assertNotNull(modelIndex);
    var visibleIndex = GridUtils.getVisibleIndex(modelIndex, movedColumns);

    // Move to after remaining frozen columns and front columns
    var newMovedColumns = GridUtils.moveItem(visibleIndex, allFrozenColumns.size + model.frontColumns.length, movedColumns);
    this.setState({
      frozenColumns: [...allFrozenColumns],
      movedColumns: newMovedColumns
    });
  }

  /**
   * Updates the entire list of frozen columns.
   * Used by VisibilityOrderingBuilder.
   * @param frozenColumns The new list of frozen columns
   */
  handleFrozenColumnsChanged(frozenColumns) {
    this.setState({
      frozenColumns
    });
  }
  toggleExpandColumn(modelIndex, expandDescendants) {
    log.debug2('Toggle expand column', modelIndex);
    var model = this.props.model;
    if (isExpandableColumnGridModel(model) && model.hasExpandableColumns) {
      model.setColumnExpanded(modelIndex, !model.isColumnExpanded(modelIndex), expandDescendants);
    }
  }
  expandAllColumns() {
    log.debug2('Expand all columns');
    var model = this.props.model;
    if (isExpandableColumnGridModel(model) && model.isExpandAllColumnsAvailable) {
      model.expandAllColumns();
    }
  }
  collapseAllColumns() {
    log.debug2('Collapse all columns');
    var model = this.props.model;
    if (isExpandableColumnGridModel(model) && model.isExpandAllColumnsAvailable) {
      model.collapseAllColumns();
    }
  }
  handleColumnVisibilityChanged(modelIndexes, isVisible) {
    var _this$grid6;
    var _this$state1 = this.state,
      metricCalculator = _this$state1.metricCalculator,
      metrics = _this$state1.metrics;
    assertNotNull(metrics);
    if (isVisible) {
      modelIndexes.forEach(modelIndex => {
        var defaultWidth = metricCalculator.initialColumnWidths.get(modelIndex);
        var calculatedWidth = metrics.calculatedColumnWidths.get(modelIndex);

        // If we haven't scrolled to the column, the calculated width will be undefined.
        // This means the function was triggered by the visibility ordering menu,
        // so just reset the column width to default.
        if (defaultWidth !== calculatedWidth && calculatedWidth != null) {
          metricCalculator.setColumnWidth(modelIndex, calculatedWidth);
        } else {
          metricCalculator.resetColumnWidth(modelIndex);
        }
      });
    } else {
      modelIndexes.forEach(modelIndex => {
        metricCalculator.setColumnWidth(modelIndex, 0);
      });
    }
    (_this$grid6 = this.grid) === null || _this$grid6 === void 0 || _this$grid6.forceUpdate();
  }
  handleColumnVisibilityReset() {
    var _model$layoutHints$fr, _model$layoutHints2;
    var metricCalculator = this.state.metricCalculator;
    var model = this.props.model;
    metricCalculator.resetAllColumnWidths();
    this.handleMovedColumnsChanged(model.initialMovedColumns);
    this.handleHeaderGroupsChanged(model.initialColumnHeaderGroups);
    this.setState({
      frozenColumns: (_model$layoutHints$fr = (_model$layoutHints2 = model.layoutHints) === null || _model$layoutHints2 === void 0 ? void 0 : _model$layoutHints2.frozenColumns) !== null && _model$layoutHints$fr !== void 0 ? _model$layoutHints$fr : EMPTY_ARRAY
    });
  }
  handleCrossColumnSearch(searchValue, selectedSearchColumns, invertSearchColumns) {
    var model = this.props.model;
    this.startLoading('Searching...');
    this.updateSearchFilter(searchValue, selectedSearchColumns, model.columns, invertSearchColumns);
    this.setState({
      searchValue,
      selectedSearchColumns,
      invertSearchColumns
    });
  }
  handleAnimationLoop() {
    var _this$grid7;
    (_this$grid7 = this.grid) === null || _this$grid7 === void 0 || _this$grid7.updateCanvas();
    if (this.isAnimating) {
      this.animationFrame = requestAnimationFrame(this.handleAnimationLoop);
    }
  }
  handleAnimationStart() {
    log.debug2('handleAnimationStart');
    this.isAnimating = true;
    this.animationFrame = requestAnimationFrame(this.handleAnimationLoop);
  }
  handleAnimationEnd() {
    log.debug2('handleAnimationEnd');
    this.isAnimating = false;
  }
  handlePartitionChange(partitionConfig) {
    this.startLoading('Partitioning...');
    var prevConfig = this.state.partitionConfig;
    if (prevConfig !== partitionConfig) {
      this.setState({
        partitionConfig
      });
    }
  }
  handleTableLoadError(error) {
    if (PromiseUtils.isCanceled(error)) {
      return;
    }
    log.error(error);
    var onError = this.props.onError;
    onError(error);
  }
  handleViewportUpdated() {
    var model = this.props.model;
    var _this$state10 = this.state,
      loadingText = _this$state10.loadingText,
      loadingSpinnerShown = _this$state10.loadingSpinnerShown;
    var loadingMessage = 'Waiting for viewport...';

    // pending and no timer already exists
    if (model.isViewportPending && !loadingSpinnerShown) {
      this.showViewportLoading();
    } else if (loadingText === loadingMessage && !model.isViewportPending) {
      // extra conditions because timeout might get cleared by update
      this.stopLoading();
    }
  }
  showAllColumns() {
    var _this$grid8;
    var metricCalculator = this.state.metricCalculator;
    var userColumnWidths = metricCalculator.getUserColumnWidths();
    var entries = [...userColumnWidths.entries()];
    for (var i = 0; i < entries.length; i += 1) {
      var _entries$i = _slicedToArray(entries[i], 2),
        modelIndex = _entries$i[0],
        columnWidth = _entries$i[1];
      if (columnWidth === 0) {
        metricCalculator.resetColumnWidth(modelIndex);
      }
    }
    (_this$grid8 = this.grid) === null || _this$grid8 === void 0 || _this$grid8.forceUpdate();
  }

  /**
   * Updates grid metrics after model columns have changed
   * to keep Grid and IrisGrid metrics in sync since metrics are stored in both places.
   */
  updateMetrics() {
    var _this$grid9;
    this.setState({
      metrics: (_this$grid9 = this.grid) === null || _this$grid9 === void 0 ? void 0 : _this$grid9.updateMetrics()
    });
  }
  toggleSort(columnIndex, addToExisting) {
    log.info('Toggling sort for column', columnIndex);
    var model = this.props.model;
    var modelColumn = this.getModelColumn(columnIndex);
    assertNotNull(modelColumn);
    if (model.isColumnSortable(columnIndex)) {
      var currentSorts = this.state.sorts;
      var sorts = TableUtils.toggleSortForColumn(currentSorts, model.columns, modelColumn, addToExisting);
      this.requestSortsChange(sorts);
    } else {
      log.debug('Column type was not sortable', model.columns[columnIndex]);
    }
  }
  updateSorts(sorts) {
    var _this$grid0;
    this.startLoading('Sorting...');
    this.setState({
      sorts
    });
    (_this$grid0 = this.grid) === null || _this$grid0 === void 0 || _this$grid0.forceUpdate();
  }
  requestSortsChange(sorts) {
    var _this$props6 = this.props,
      isSortsControlled = _this$props6.isSortsControlled,
      onSortsChange = _this$props6.onSortsChange;
    onSortsChange === null || onSortsChange === void 0 || onSortsChange(sorts);
    if (!isSortsControlled) {
      this.updateSorts(sorts);
    }
  }
  updateQuickFilters(quickFilters) {
    var _this$grid1;
    var currentQuickFilters = this.state.quickFilters;
    if (quickFilters == null) {
      if (currentQuickFilters.size === 0) {
        return;
      }
    } else if (quickFilters === currentQuickFilters) {
      return;
    }
    this.startLoading('Filtering...', {
      resetRanges: true
    });
    this.setState({
      quickFilters: quickFilters !== null && quickFilters !== void 0 ? quickFilters : EMPTY_MAP
    });
    (_this$grid1 = this.grid) === null || _this$grid1 === void 0 || _this$grid1.forceUpdate();
  }
  requestQuickFiltersChange(quickFilters) {
    var _this$props7 = this.props,
      isQuickFiltersControlled = _this$props7.isQuickFiltersControlled,
      onQuickFiltersChange = _this$props7.onQuickFiltersChange;
    onQuickFiltersChange === null || onQuickFiltersChange === void 0 || onQuickFiltersChange(quickFilters);
    if (!isQuickFiltersControlled) {
      this.updateQuickFilters(quickFilters);
    }
  }
  sortColumn(modelColumn) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TableUtils.sortDirection.none;
    var isAbs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var addToExisting = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    assertNotNull(modelColumn);
    var model = this.props.model;
    var sorts = TableUtils.sortColumn(model.sort, model.columns, modelColumn, direction, isAbs, addToExisting);
    this.requestSortsChange(sorts);
  }
  reverse(reverse) {
    var _this$grid10;
    this.startLoading('Reversing...');
    this.setState({
      reverse
    });
    (_this$grid10 = this.grid) === null || _this$grid10 === void 0 || _this$grid10.forceUpdate();
  }
  isReversible() {
    var model = this.props.model;
    return model.isReversible;
  }
  toggleFilterBar() {
    var focusIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.lastFocusedFilterBarColumn;
    var isFilterBarShown = this.state.isFilterBarShown;
    isFilterBarShown = !isFilterBarShown;
    this.setState({
      isFilterBarShown
    });
    if (isFilterBarShown) {
      if (focusIndex != null) {
        this.focusFilterBar(focusIndex);
      } else {
        var columnIndex = 0;
        var model = this.props.model;
        var columnCount = model.columnCount;
        for (var i = 0; i < columnCount; i += 1) {
          var modelColumn = this.getModelColumn(i);
          if (modelColumn != null) {
            var column = model.columns[modelColumn];
            if (column != null && TableUtils.isTextType(column.type)) {
              columnIndex = i;
              break;
            }
          }
        }
        this.focusFilterBar(columnIndex);
      }
    } else {
      var _this$grid11;
      (_this$grid11 = this.grid) === null || _this$grid11 === void 0 || _this$grid11.focus();
    }
  }
  isTableSearchAvailable() {
    var _model$layoutHints3, _dh$SearchDisplayMode, _dh$SearchDisplayMode2;
    var _this$props8 = this.props,
      model = _this$props8.model,
      canToggleSearch = _this$props8.canToggleSearch;
    var dh = model.dh;
    var searchDisplayMode = model === null || model === void 0 || (_model$layoutHints3 = model.layoutHints) === null || _model$layoutHints3 === void 0 ? void 0 : _model$layoutHints3.searchDisplayMode;
    if (searchDisplayMode === ((_dh$SearchDisplayMode = dh.SearchDisplayMode) === null || _dh$SearchDisplayMode === void 0 ? void 0 : _dh$SearchDisplayMode.SEARCH_DISPLAY_HIDE)) {
      return false;
    }
    if (searchDisplayMode === ((_dh$SearchDisplayMode2 = dh.SearchDisplayMode) === null || _dh$SearchDisplayMode2 === void 0 ? void 0 : _dh$SearchDisplayMode2.SEARCH_DISPLAY_SHOW)) {
      return true;
    }
    return canToggleSearch;
  }
  toggleSearchBar() {
    var showSearchBar = this.state.showSearchBar;
    if (!this.isTableSearchAvailable()) {
      return;
    }
    var update = !showSearchBar;
    this.setState({
      showSearchBar: update
    }, () => {
      var _this$crossColumnRef;
      if (update && (_this$crossColumnRef = this.crossColumnRef) !== null && _this$crossColumnRef !== void 0 && _this$crossColumnRef.current) {
        var _this$crossColumnRef2;
        (_this$crossColumnRef2 = this.crossColumnRef) === null || _this$crossColumnRef2 === void 0 || _this$crossColumnRef2.current.focus();
      } else {
        var _this$grid12;
        (_this$grid12 = this.grid) === null || _this$grid12 === void 0 || _this$grid12.focus();
      }
    });
  }
  toggleGotoRow() {
    var _this$grid13, _this$grid14;
    var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var columnName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var isGotoShown = this.state.isGotoShown;
    if (row || value) {
      var _this$gotoRowRef$curr;
      // if invoked with a row, keep open instead of toggle
      this.setState({
        isGotoShown: true,
        gotoValue: value,
        gotoValueSelectedColumnName: columnName,
        gotoRowError: '',
        gotoValueError: '',
        gotoValueManuallyChanged: false
      });
      this.focusRowInGrid(row);
      (_this$gotoRowRef$curr = this.gotoRowRef.current) === null || _this$gotoRowRef$curr === void 0 || _this$gotoRowRef$curr.focus();
      return;
    }
    var cursorRow = (_this$grid13 = this.grid) === null || _this$grid13 === void 0 ? void 0 : _this$grid13.state.cursorRow;
    var cursorColumn = (_this$grid14 = this.grid) === null || _this$grid14 === void 0 ? void 0 : _this$grid14.state.cursorColumn;
    if (cursorRow == null || cursorColumn == null) {
      // if a cell is not selected / grid is not rendered
      this.setState({
        isGotoShown: !isGotoShown,
        gotoRow: '',
        gotoValue: '',
        gotoRowError: '',
        gotoValueError: '',
        gotoValueManuallyChanged: false
      });
      return;
    }
    // if a row is selected
    var model = this.props.model;
    var name = model.columns[cursorColumn].name;

    // Use raw value (same as Copy Cell Unformatted) to preserve full precision and timezone
    var text = String(this.getValueForCell(cursorColumn, cursorRow, true));
    this.setState({
      isGotoShown: !isGotoShown,
      gotoRow: "".concat(cursorRow + 1),
      gotoValue: text,
      gotoValueSelectedColumnName: name,
      gotoRowError: '',
      gotoValueError: '',
      gotoValueManuallyChanged: false
    });
  }
  commitPending() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      var _document;
      var model = _this3.props.model;
      if (!isEditableGridModel(model) || !model.isEditable) {
        throw new Error('Cannot save, table is not editable');
      }
      var pendingSavePromise = _this3.state.pendingSavePromise;
      if (pendingSavePromise != null) {
        throw new Error('Save already in progress');
      }
      var containsGridCellInputField = (_document = document) === null || _document === void 0 || (_document = _document.activeElement) === null || _document === void 0 ? void 0 : _document.classList.contains('grid-cell-input-field');
      if (containsGridCellInputField != null && containsGridCellInputField) {
        var _this3$grid;
        if (document.activeElement != null && document.activeElement.classList.contains('error')) {
          throw new ValidationError('Current input is invalid');
        }

        // Focus the grid again to commit any pending input changes
        (_this3$grid = _this3.grid) === null || _this3$grid === void 0 || _this3$grid.focus();
      }
      var newPendingSavePromise = _this3.pending.add(model.commitPending()).then(() => {
        _this3.setState({
          pendingSaveError: null,
          pendingSavePromise: null
        });
      }).catch(err => {
        if (!PromiseUtils.isCanceled(err)) {
          _this3.setState({
            pendingSaveError: err,
            pendingSavePromise: null
          });
        }
      });
      _this3.setState({
        pendingSavePromise: newPendingSavePromise
      });
      return newPendingSavePromise;
    })();
  }
  discardPending() {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var pendingSavePromise = _this4.state.pendingSavePromise;
      if (pendingSavePromise != null) {
        throw new Error('Cannot cancel a save in progress');
      }
      _this4.setState({
        pendingSavePromise: null,
        pendingSaveError: null,
        pendingDataMap: new Map(),
        pendingDataErrors: new Map()
      });
    })();
  }

  /**
   * Select the passed in column and notify listener
   * @param column The column in this table to link
   */
  selectColumn(column) {
    var onColumnSelected = this.props.onColumnSelected;
    onColumnSelected(column);
  }

  /**
   * Get the row data map for a given row and notifies the listener
   */
  selectData(columnIndex, rowIndex) {
    var dataMap = this.getRowDataMap(rowIndex);
    var onDataSelected = this.props.onDataSelected;
    onDataSelected(rowIndex, dataMap);
  }

  /**
   * Get the data map for the given row
   * @param rowIndex Row to get the data map for
   * @returns Data map for the row
   */
  getRowDataMap(rowIndex) {
    var _this5 = this;
    var model = this.props.model;
    var columns = model.columns,
      groupedColumns = model.groupedColumns;
    var dataMap = {};
    var _loop = function _loop() {
      var column = columns[i];
      var name = column.name,
        type = column.type;
      var value = model.valueForCell(i, rowIndex);
      var text = model.textForCell(i, rowIndex);
      var visibleIndex = _this5.getVisibleColumn(i);
      var isExpandable = isExpandableGridModel(model) && model.isRowExpandable(rowIndex);
      var isGrouped = groupedColumns.find(c => c.name === name) != null;
      dataMap[name] = {
        value,
        text,
        type,
        isGrouped,
        isExpandable,
        visibleIndex
      };
    };
    for (var i = 0; i < columns.length; i += 1) {
      _loop();
    }
    return dataMap;
  }
  handleAdvancedFilterChange(column, filter, options) {
    var model = this.props.model;
    var index = model.getColumnIndexByName(column.name);
    assertNotNull(index);
    this.setAdvancedFilter(index, filter, options);
  }
  handleAdvancedFilterSortChange(column, direction) {
    var addToExisting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var model = this.props.model;
    var columnIndex = model.getColumnIndexByName(column.name);
    assertNotNull(columnIndex);
    var columnName = model.columns[columnIndex].name;
    var oldSort = TableUtils.getSortForColumn(model.sort, columnName);
    var newSort = null;
    if (oldSort == null || oldSort.direction !== direction) {
      if (direction === TableUtils.sortDirection.descending) {
        newSort = column.sort().desc();
      } else {
        newSort = column.sort().asc();
      }
    }
    var sorts = TableUtils.setSortForColumn(model.sort, columnName, newSort, addToExisting);
    log.info('Setting table sorts', sorts);
    this.requestSortsChange(sorts);
  }
  handleAdvancedFilterDone() {
    var _this$grid15;
    (_this$grid15 = this.grid) === null || _this$grid15 === void 0 || _this$grid15.focus();
  }
  handleAdvancedFilterToggleMaximize(column) {
    this.setState(_ref12 => {
      var maximizedAdvancedFilter = _ref12.maximizedAdvancedFilter;
      return {
        maximizedAdvancedFilter: maximizedAdvancedFilter === column ? null : column
      };
    });
  }
  handleAdvancedMenuOpened(column) {
    this.setState({
      shownAdvancedFilter: column,
      maximizedAdvancedFilter: null
    });
  }
  handleGotoRowOpened() {
    this.setState({
      isGotoShown: true,
      gotoValueManuallyChanged: false
    });
  }
  handleGotoRowClosed() {
    this.setState({
      isGotoShown: false,
      gotoValueManuallyChanged: false
    });
  }
  handleAdvancedMenuClosed(columnIndex) {
    var _this$filterInputRef;
    var _this$state11 = this.state,
      focusedFilterBarColumn = _this$state11.focusedFilterBarColumn,
      isFilterBarShown = _this$state11.isFilterBarShown;
    if (isFilterBarShown && focusedFilterBarColumn === columnIndex && ((_this$filterInputRef = this.filterInputRef) === null || _this$filterInputRef === void 0 ? void 0 : _this$filterInputRef.current) !== null) {
      var _this$filterInputRef2;
      (_this$filterInputRef2 = this.filterInputRef) === null || _this$filterInputRef2 === void 0 || _this$filterInputRef2.current.focus();
      this.setState({
        shownAdvancedFilter: null,
        maximizedAdvancedFilter: null
      });
    } else {
      this.setState({
        focusedFilterBarColumn: null,
        shownAdvancedFilter: null,
        maximizedAdvancedFilter: null
      });
    }
  }
  handleCancel() {
    this.rollback();
  }

  // eslint-disable-next-line class-methods-use-this
  handleChartChange() {
    // TODO: IDS-4242 Update Chart Preview
  }
  handleChartCreate(settings) {
    var _this$props9 = this.props,
      model = _this$props9.model,
      onCreateChart = _this$props9.onCreateChart;
    onCreateChart(settings, model);
  }
  handleGridError(error) {
    log.warn('Grid Error', error);
    this.setState({
      toastMessage: /*#__PURE__*/_jsx("div", {
        className: "error-message",
        children: "".concat(error)
      })
    });
  }
  handleFilterBarChange(value) {
    var _this$state12 = this.state,
      focusedFilterBarColumn = _this$state12.focusedFilterBarColumn,
      quickFilters = _this$state12.quickFilters;
    var newQuickFilters = new Map(quickFilters);
    if (focusedFilterBarColumn != null) {
      var modelIndex = this.getModelColumn(focusedFilterBarColumn);
      assertNotNull(modelIndex);
      this.applyQuickFilter(modelIndex, value, newQuickFilters);
    }
    this.requestQuickFiltersChange(newQuickFilters);
  }
  handleFilterBarDone() {
    var setGridFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var defocusInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (setGridFocus) {
      var _this$grid16;
      (_this$grid16 = this.grid) === null || _this$grid16 === void 0 || _this$grid16.focus();
    }
    if (defocusInput) {
      this.setState({
        focusedFilterBarColumn: null
      });
    }
  }
  handleFilterBarTab(backward) {
    var focusedFilterBarColumn = this.state.focusedFilterBarColumn;
    assertNotNull(focusedFilterBarColumn);
    if (backward) {
      this.focusFilterBar(focusedFilterBarColumn - 1);
    } else {
      this.focusFilterBar(focusedFilterBarColumn + 1);
    }
  }
  handleFormatSelection(modelIndex, selectedFormat) {
    var model = this.props.model;
    var column = model.columns[modelIndex];
    var prevCustomColumnFormatMap = this.state.customColumnFormatMap;
    var customColumnFormatMap = new Map(prevCustomColumnFormatMap);
    if (selectedFormat != null) {
      var normalizedType = TableUtils.getNormalizedType(column.type);
      assertNotNull(normalizedType);
      var columnFormattingRule = Formatter.makeColumnFormattingRule(normalizedType, column.name, selectedFormat);
      customColumnFormatMap.set(column.name, columnFormattingRule);
    } else {
      customColumnFormatMap.delete(column.name);
    }
    this.updateFormatter({
      customColumnFormatMap
    });
  }
  handleColumnAlignmentChange(modelIndex, alignment) {
    var model = this.props.model;
    var column = model.columns[modelIndex];
    this.setState(_ref13 => {
      var _ref13$columnAlignmen = _ref13.columnAlignmentMap,
        columnAlignmentMap = _ref13$columnAlignmen === void 0 ? EMPTY_MAP : _ref13$columnAlignmen;
      var newColumnAlignmentMap = new Map(columnAlignmentMap);
      if (alignment != null) {
        newColumnAlignmentMap.set(column.name, alignment);
      } else {
        newColumnAlignmentMap.delete(column.name);
      }
      return {
        columnAlignmentMap: newColumnAlignmentMap
      };
    });
  }
  handleMenu(e) {
    e.stopPropagation();
    this.setState({
      isMenuShown: true
    });
  }
  handleMenuClose() {
    this.setState({
      isMenuShown: false,
      openOptions: []
    });
  }
  handleMenuBack() {
    this.setState(_ref14 => {
      var openOptions = _ref14.openOptions;
      var newOptions = [...openOptions];
      newOptions.pop();
      return {
        openOptions: newOptions
      };
    });
  }
  handleMenuSelect(option) {
    this.setState(_ref15 => {
      var openOptions = _ref15.openOptions;
      return {
        openOptions: [...openOptions, option]
      };
    });
  }
  handleRequestFailed(event) {
    var _ref16 = event,
      error = _ref16.detail;
    log.error('request failed:', error);
    this.stopLoading();
    var _this$state13 = this.state,
      partitionConfig = _this$state13.partitionConfig,
      conditionalFormatEditIndex = _this$state13.conditionalFormatEditIndex;
    if (isMissingPartitionError(error) && partitionConfig != null) {
      // We'll try loading the initial partition again
      this.startLoading('Reloading partition...', {
        resetRanges: true
      });
      this.setState({
        partitionConfig: undefined
      }, () => {
        this.initState();
      });
    } else if (conditionalFormatEditIndex !== null) {
      var _errorMessage;
      // Preview format failed — surface error in the editor instead of rolling back
      var errorMessage = (_errorMessage = error === null || error === void 0 ? void 0 : error.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : String(error);
      this.setState({
        conditionalFormatError: errorMessage,
        conditionalFormatPreview: undefined
      });
    } else if (this.canRollback()) {
      this.startLoading('Rolling back changes...', {
        resetRanges: true
      });
      this.rollback();
    } else {
      log.error('Table failed and unable to rollback');
      var onError = this.props.onError;
      onError(new Error("Error displaying table: ".concat(error)));
    }
  }

  /**
   * Raise the loading scrim in response to a model-driven `PENDING` event. The
   * model is the start signal, mirroring how `UPDATED`/`COLUMNS_CHANGED` are
   * already the model-driven stop signal. Idempotent: the first message within
   * a commit wins (the `loadingScrimStartTime == null` guard collapses multiple
   * pending operations into a single scrim).
   */
  handlePending(event) {
    var _ref17 = event,
      detail = _ref17.detail;
    var _ref18 = detail !== null && detail !== void 0 ? detail : {},
      text = _ref18.text,
      options = _ref18.options;
    if (this.loadingScrimStartTime == null) {
      this.startLoading(text !== null && text !== void 0 ? text : 'Loading...', _objectSpread({
        loadingCancelShown: false
      }, options));
    }
  }

  /**
   * Clear the loading scrim in response to a model-driven `PENDING_CLEARED`
   * event. Only needed for operations that do not naturally end in
   * `UPDATED`/`COLUMNS_CHANGED`/`REQUEST_FAILED`.
   *
   * The current contract assumes a single outstanding model-driven operation:
   * `handlePending` collapses concurrent `PENDING` events into one scrim, so
   * this clears unconditionally. That is consistent with the existing scrim,
   * which any model stop signal already clears regardless of what else is in
   * flight. Ref-counting overlapping operations is intentionally deferred to
   * the planned migration that routes the built-in `startLoading` calls
   * through `PENDING`/`PENDING_CLEARED`; only once every raise/clear goes
   * through this pair can a depth counter stay balanced (a counter added now
   * would desync against the direct `startLoading` callers).
   */
  handlePendingCleared() {
    this.stopLoading();
  }
  handleUpdate() {
    var _this$grid17;
    log.debug2('Received model update');
    var _this$state14 = this.state,
      advancedFilters = _this$state14.advancedFilters,
      aggregationSettings = _this$state14.aggregationSettings,
      conditionalFormats = _this$state14.conditionalFormats,
      conditionalFormatEditIndex = _this$state14.conditionalFormatEditIndex,
      conditionalFormatPreview = _this$state14.conditionalFormatPreview,
      customColumns = _this$state14.customColumns,
      quickFilters = _this$state14.quickFilters,
      reverse = _this$state14.reverse,
      rollupConfig = _this$state14.rollupConfig,
      searchFilter = _this$state14.searchFilter,
      selectDistinctColumns = _this$state14.selectDistinctColumns,
      sorts = _this$state14.sorts;
    var config = {
      advancedFilters,
      aggregationSettings,
      conditionalFormats,
      conditionalFormatEditIndex,
      conditionalFormatPreview,
      customColumns,
      quickFilters,
      reverse,
      rollupConfig,
      searchFilter,
      selectDistinctColumns,
      sorts
    };
    if (!IrisGridUtils.isEmptyConfig(config)) {
      this.lastLoadedConfig = config;
    } else {
      this.lastLoadedConfig = null;
    }
    (_this$grid17 = this.grid) === null || _this$grid17 === void 0 || _this$grid17.forceUpdate();
    this.stopLoading();
  }
  handleTableChanged() {
    var model = this.props.model;
    // For partitioned tables, we want to rebuild filters on table change to ensure filters are applied to the new partition
    var partitionConfig = this.state.partitionConfig;
    if (isPartitionedGridModel(model) && (partitionConfig === null || partitionConfig === void 0 ? void 0 : partitionConfig.mode) !== 'keys') {
      this.rebuildFilters();
    }
  }

  /**
   * Handle an inner-model swap on a proxy model (`SCHEMA_CHANGED`). The previous
   * model's `movedColumns` reference indices that may not exist in the new
   * model (e.g. a pivot exposes a different column set), so reset them to the
   * new model's initial order. The metric calculator is rebuilt separately when
   * the `getMetricCalculator` prop changes (see `componentDidUpdate`); a calc
   * whose seed `movedColumns` are now stale self-heals because `getMetrics`
   * reconciles against the grid's current `movedColumns` at draw time.
   */
  handleSchemaChanged() {
    var model = this.props.model;
    this.setState({
      movedColumns: model.initialMovedColumns
    });
  }
  handleViewChanged(metrics) {
    var _this$grid$state, _this$grid18;
    var model = this.props.model;
    var _ref19 = (_this$grid$state = (_this$grid18 = this.grid) === null || _this$grid18 === void 0 ? void 0 : _this$grid18.state) !== null && _this$grid$state !== void 0 ? _this$grid$state : {},
      _ref19$selectionEndRo = _ref19.selectionEndRow,
      selectionEndRow = _ref19$selectionEndRo === void 0 ? 0 : _ref19$selectionEndRo;
    var pendingRowCount = 0;
    if (isEditableGridModel(model) && model.isEditable) {
      assertNotNull(metrics);
      var bottomViewport = metrics.bottomViewport;

      // We have an editable table that we can add new rows to
      // Display empty rows beneath the table rows that user can fill in
      var bottomNonFloating = model.rowCount - model.floatingBottomRowCount;
      if (selectionEndRow === bottomNonFloating - 1) {
        // Selection is in the last row, add another blank row
        pendingRowCount = model.pendingRowCount + 1;
      } else if (selectionEndRow === bottomNonFloating - 2) {
        // We may have just added a row based on selection moving, so just leave it as is
        pendingRowCount = model.pendingRowCount;
      } else {
        // Otherwise fill up the viewport with empty cells
        pendingRowCount = Math.max(0, bottomViewport - (model.rowCount - model.pendingRowCount) - model.floatingTopRowCount - model.floatingBottomRowCount - 1);
      }
    }
    this.setState({
      metrics,
      pendingRowCount
    });
  }
  handleSelectionChanged(selectedRanges) {
    assertNotNull(selectedRanges);
    var onSelectionChanged = this.props.onSelectionChanged;
    var copyOperation = this.state.copyOperation;
    this.setState({
      selectedRanges
    });
    if (copyOperation != null) {
      this.setState({
        copyOperation: null
      });
    }

    // We get 2 identical ranges here,
    // but consolidating in `Grid#moveSelection` causes
    // deselection to break, so just consolidate here.
    // This will only update the goto row input for row index
    if (GridRange.rowCount(GridRange.consolidate(selectedRanges)) === 1 && selectedRanges[0].startRow != null) {
      this.setState({
        gotoRow: "".concat(selectedRanges[0].startRow + 1)
      });
    }
    onSelectionChanged(selectedRanges);
  }
  handleMovedColumnsChanged(movedColumns, onChangeApplied) {
    this.setState({
      movedColumns
    }, onChangeApplied);
  }
  handleHeaderGroupsChanged(columnHeaderGroups) {
    var model = this.props.model;
    var prevColumnHeaderGroups = this.state.columnHeaderGroups;
    if (prevColumnHeaderGroups === columnHeaderGroups) {
      return;
    }
    this.setState({
      // undo/redo will pass already parsed groups
      // Parsing them again causes a loop with undo/redo that makes it unusable
      columnHeaderGroups: columnHeaderGroups.every(group => isColumnHeaderGroup(group) && group.isValid()) ? columnHeaderGroups : IrisGridUtils.parseColumnHeaderGroups(model, columnHeaderGroups).groups
    }, () => {
      var _this$grid19;
      return (_this$grid19 = this.grid) === null || _this$grid19 === void 0 ? void 0 : _this$grid19.forceUpdate();
    });
  }
  handleTooltipRef(tooltip) {
    // Need to start the timer right away, since we're creating the tooltip when we want the timer to start
    if (tooltip != null) {
      tooltip.startTimer();
    }
    this.tooltip = tooltip;
  }
  handleConditionalFormatsChange(conditionalFormats) {
    log.debug('Updated conditional formats', conditionalFormats);
    this.setState({
      conditionalFormats
    });
  }
  handleConditionalFormatCreate() {
    log.debug('Create new conditional format');
    var _this$state15 = this.state,
      openOptions = _this$state15.openOptions,
      conditionalFormats = _this$state15.conditionalFormats;
    this.setState({
      openOptions: [...openOptions, {
        type: OptionType.CONDITIONAL_FORMATTING_EDIT,
        title: "Create Formatting Rule"
      }],
      conditionalFormatEditIndex: conditionalFormats.length,
      // Start with a blank rule
      conditionalFormatPreview: undefined
    });
  }
  handleConditionalFormatEdit(index) {
    log.debug('Edit conditional format', index);
    var _this$state16 = this.state,
      openOptions = _this$state16.openOptions,
      conditionalFormats = _this$state16.conditionalFormats;
    this.setState({
      openOptions: [...openOptions, {
        type: OptionType.CONDITIONAL_FORMATTING_EDIT,
        title: "Edit Formatting Rule"
      }],
      conditionalFormatEditIndex: index,
      // Clone rule to preview temporary changes
      conditionalFormatPreview: _objectSpread({}, conditionalFormats[index])
    });
  }
  handleConditionalFormatEditorSave(config) {
    log.debug('Save conditional format changes', config);
    this.setState(state => {
      if (state.conditionalFormatEditIndex === null) {
        log.debug('Invalid format index');
        return null;
      }
      var conditionalFormats = [...state.conditionalFormats];
      conditionalFormats[state.conditionalFormatEditIndex] = config;
      return {
        conditionalFormats
      };
    }, () => {
      this.handleMenuBack();
    });
  }
  handleConditionalFormatEditorCancel() {
    this.handleMenuBack();
    // Not resetting conditionalFormatPreview here
    // to prevent editor fields change during the menu transition
    this.setState({
      conditionalFormatEditIndex: null,
      conditionalFormatError: null
    });
  }
  handleUpdateCustomColumns(customColumns) {
    log.info("handleUpdateCustomColumns:", customColumns);
    var model = this.props.model;
    var _this$state17 = this.state,
      movedColumns = _this$state17.movedColumns,
      sorts = _this$state17.sorts,
      quickFilters = _this$state17.quickFilters,
      advancedFilters = _this$state17.advancedFilters,
      selectDistinctColumns = _this$state17.selectDistinctColumns;
    var columns = model.columns;
    var oldCustomColumns = model.customColumns.map(customColumn => "".concat(customColumn));
    var removedColumnNames = IrisGridUtils.getRemovedCustomColumnNames(oldCustomColumns, customColumns);
    if (removedColumnNames.length > 0) {
      var newSorts = IrisGridUtils.removeSortsInColumns(sorts, removedColumnNames);
      var newQuickFilters = IrisGridUtils.removeFiltersInColumns(columns, quickFilters, removedColumnNames);
      var newAdvancedFilters = IrisGridUtils.removeFiltersInColumns(columns, advancedFilters, removedColumnNames);
      var newMovedColumns = IrisGridUtils.removeColumnFromMovedColumns(columns, movedColumns, removedColumnNames);
      var newSelectDistinctColumns = IrisGridUtils.removeColumnsFromSelectDistinctColumns(selectDistinctColumns, removedColumnNames);
      if (newSorts.length !== sorts.length) {
        log.debug('removing sorts from removed custom columns...');
        this.requestSortsChange(newSorts);
      }
      if (newQuickFilters.size !== quickFilters.size || newAdvancedFilters.size !== advancedFilters.size) {
        log.debug("removing filters from removed custom columns...");
        if (newQuickFilters.size !== quickFilters.size) {
          this.requestQuickFiltersChange(newQuickFilters);
        }
        if (newAdvancedFilters.size !== advancedFilters.size) {
          this.setState({
            advancedFilters: newAdvancedFilters
          });
        }
      }
      if (!deepEqual(movedColumns, newMovedColumns)) {
        log.debug("change moved columns for removed custom columns", newMovedColumns);
        this.setState({
          movedColumns: newMovedColumns
        });
      }
      if (!deepEqual(selectDistinctColumns, newSelectDistinctColumns)) {
        log.debug("change selectDistinct columns for removed custom columns", newMovedColumns);
        this.setState({
          selectDistinctColumns: newSelectDistinctColumns
        });
      }
    }
    this.setState({
      customColumns
    });
    if (customColumns.length > 0) {
      // If there are no custom columns, the change handler never fires
      // This causes the loader to stay until canceled by the user
      this.startLoading('Applying custom columns...');
    }
  }
  handleCustomColumnsChanged() {
    log.debug('Model columns changed');
    var isReady = this.state.isReady;
    if (isReady) {
      this.updateMetrics();

      // Make sure stopLoading() is called after the updateMetrics call,
      // otherwise IrisGridModelUpdater queues an extra setViewport based on old metrics.
      this.stopLoading();
    } else {
      this.loadTableState();
    }
  }

  /**
   * Rebuild the metric calculator when the `getMetricCalculator` prop swaps for
   * a different factory (e.g. entering or leaving a pivot, where the
   * pivot-builder middleware flips the prop). The renderer and mouse handlers
   * are recomputed via their memoized getters on the next render and do not
   * need explicit handling here.
   *
   * User column-widths / row-heights from the previous calculator are not
   * carried over: a factory swap means the column set has effectively changed,
   * so the stored sizes wouldn't map to anything meaningful.
   *
   * Moved columns are NOT reset here — that is owned by `handleSchemaChanged`
   * (the `SCHEMA_CHANGED` event) so that a plain prop swap against the same
   * model preserves the user's layout. The new calculator is seeded with the
   * current moved columns; `getMetrics` reconciles against the grid's live
   * `movedColumns` at draw time, so a later reset stays consistent.
   */
  maybeRebuildMetricCalculator() {
    var _model$layoutHints4;
    var getMetricCalculator = this.props.getMetricCalculator;
    if (getMetricCalculator === this.lastMetricCalculatorFactory) return;
    var model = this.props.model;
    var movedColumns = this.state.movedColumns;
    var next = getMetricCalculator({
      userColumnWidths: new Map(),
      userRowHeights: new Map(),
      movedColumns,
      initialColumnWidths: new Map(model === null || model === void 0 || (_model$layoutHints4 = model.layoutHints) === null || _model$layoutHints4 === void 0 || (_model$layoutHints4 = _model$layoutHints4.hiddenColumns) === null || _model$layoutHints4 === void 0 ? void 0 : _model$layoutHints4.map(name => [model.getColumnIndexByName(name), 0]))
    });
    this.lastMetricCalculatorFactory = getMetricCalculator;
    log.debug('Swapping metric calculator', next);
    // Also push the new calculator onto the Grid synchronously so any
    // immediately-following read of `Grid.metricCalculator` (before React has
    // committed the setState below) uses the new instance against the new
    // model rather than invoking the old calculator and potentially throwing.
    if (this.grid != null) {
      this.grid.metricCalculator = next;
    }
    this.setState({
      metricCalculator: next
    });
  }
  handlePendingCommitClicked() {
    return this.commitPending();
  }
  handlePendingDiscardClicked() {
    return this.discardPending();
  }
  handlePendingDataUpdated() {
    var _this$grid20;
    log.debug('pending data updated');
    var model = this.props.model;
    var pendingDataMap = model.pendingDataMap,
      pendingDataErrors = model.pendingDataErrors;
    this.setState({
      pendingDataMap,
      pendingDataErrors,
      pendingSaveError: null
    });
    (_this$grid20 = this.grid) === null || _this$grid20 === void 0 || _this$grid20.forceUpdate();
  }
  handleResizeColumn(modelIndex) {
    var _this$grid21;
    var _this$state18 = this.state,
      metrics = _this$state18.metrics,
      metricCalculator = _this$state18.metricCalculator;
    if (!metrics) throw new Error('Metrics not set');
    var contentWidth = getOrThrow(metrics.contentColumnWidths, modelIndex);
    var userWidths = metricCalculator.getUserColumnWidths();
    if (userWidths.has(modelIndex)) {
      metricCalculator.resetColumnWidth(modelIndex);
      metricCalculator.setCalculatedColumnWidth(modelIndex, contentWidth);
    } else {
      metricCalculator.setColumnWidth(modelIndex, contentWidth);
    }
    (_this$grid21 = this.grid) === null || _this$grid21 === void 0 || _this$grid21.forceUpdate();
  }
  handleResizeAllColumns() {
    var _this$grid22;
    var _this$state19 = this.state,
      metrics = _this$state19.metrics,
      metricCalculator = _this$state19.metricCalculator;
    if (!metrics) throw new Error('Metrics not set');
    var allColumns = [...metrics.allColumnWidths.entries()];
    var visibleColumns = allColumns.filter(_ref20 => {
      var _ref21 = _slicedToArray(_ref20, 2),
        _ = _ref21[0],
        width = _ref21[1];
      return width !== 0;
    }).map(_ref22 => {
      var _ref23 = _slicedToArray(_ref22, 1),
        modelIndex = _ref23[0];
      return modelIndex;
    });
    var contentWidths = metrics.contentColumnWidths;
    var userWidths = metricCalculator.getUserColumnWidths();
    var manualColumns = visibleColumns.filter(modelIndex => userWidths.has(modelIndex));
    if (visibleColumns.length === manualColumns.length) {
      // All columns are manually sized, flip all to auto resize
      for (var i = 0; i < visibleColumns.length; i += 1) {
        var modelIndex = visibleColumns[i];
        var contentWidth = getOrThrow(contentWidths, modelIndex);
        metricCalculator.resetColumnWidth(modelIndex);
        metricCalculator.setCalculatedColumnWidth(modelIndex, contentWidth);
      }
    } else {
      // Flip all to manual sized
      for (var _i3 = 0; _i3 < visibleColumns.length; _i3 += 1) {
        var _modelIndex = visibleColumns[_i3];
        var _contentWidth = getOrThrow(contentWidths, _modelIndex);
        metricCalculator.setColumnWidth(_modelIndex, _contentWidth);
      }
    }
    (_this$grid22 = this.grid) === null || _this$grid22 === void 0 || _this$grid22.forceUpdate();
  }

  /**
   * User added, removed, or changed the order of aggregations, or position
   * @param aggregationSettings The new aggregation settings
   * @param added The aggregations that were added
   * @param removed The aggregations that were removed
   */
  handleAggregationsChange(aggregationSettings) {
    var _rollupConfig$columns, _rollupConfig$columns2;
    var added = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var removed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    log.debug('handleAggregationsChange', aggregationSettings, added, removed);
    var rollupConfig = this.state.rollupConfig;
    var isRollup = ((_rollupConfig$columns = rollupConfig === null || rollupConfig === void 0 || (_rollupConfig$columns2 = rollupConfig.columns) === null || _rollupConfig$columns2 === void 0 ? void 0 : _rollupConfig$columns2.length) !== null && _rollupConfig$columns !== void 0 ? _rollupConfig$columns : 0) > 0;
    // Do not start loading if this is rollup and added / removed aggregations are prohibited for rollups
    var changes = [...added, ...removed];
    var shouldStartLoading = !(isRollup && changes.length > 0 && changes.every(op => AggregationUtils.isRollupProhibited(op)));
    if (shouldStartLoading) {
      this.startLoading("Aggregating ".concat(aggregationSettings.aggregations.map(a => a.operation).join(', '), "..."));
    }
    this.setState({
      aggregationSettings
    });
  }

  /**
   * A specific aggregation has been modified
   * @param aggregation The new aggregation
   */
  handleAggregationChange(aggregation) {
    var _rollupConfig$columns3, _rollupConfig$columns4;
    log.debug('handleAggregationChange', aggregation);
    var rollupConfig = this.state.rollupConfig;
    var isRollup = ((_rollupConfig$columns3 = rollupConfig === null || rollupConfig === void 0 || (_rollupConfig$columns4 = rollupConfig.columns) === null || _rollupConfig$columns4 === void 0 ? void 0 : _rollupConfig$columns4.length) !== null && _rollupConfig$columns3 !== void 0 ? _rollupConfig$columns3 : 0) > 0;
    // Do not start loading if this is rollup and the aggregation is prohibited for rollups
    var shouldStartLoading = !(isRollup && AggregationUtils.isRollupProhibited(aggregation.operation));
    if (shouldStartLoading) {
      this.startLoading("Aggregating ".concat(aggregation.operation, "..."));
    }
    this.setState(_ref24 => {
      var aggregationSettings = _ref24.aggregationSettings;
      return {
        selectedAggregation: aggregation,
        aggregationSettings: _objectSpread(_objectSpread({}, aggregationSettings), {}, {
          aggregations: aggregationSettings.aggregations.map(a => a.operation === aggregation.operation ? aggregation : a)
        })
      };
    });
  }

  /**
   * An aggregations has been selected for editing
   * @param aggregation The aggregation to edit
   */
  handleAggregationEdit(aggregation) {
    log.debug('handleAggregationEdit', aggregation);
    var openOptions = this.state.openOptions;
    this.setState({
      openOptions: [...openOptions, {
        type: OptionType.AGGREGATION_EDIT,
        title: "Edit Columns to ".concat(aggregation.operation)
      }],
      selectedAggregation: aggregation
    });
  }
  handleRollupChange(rollupConfig) {
    var _rollupConfig$columns5, _rollupConfig$columns6;
    log.info('Rollup change', rollupConfig);

    // Un-hide hidden group-by columns.
    if ((rollupConfig === null || rollupConfig === void 0 ? void 0 : rollupConfig.columns) != null && rollupConfig.columns.length > 0) {
      var metricCalculator = this.state.metricCalculator;
      var userColumnWidthsByName = metricCalculator.getUserColumnWidthsByName();
      rollupConfig.columns.forEach(name => {
        if (userColumnWidthsByName.get(name) === 0) {
          metricCalculator.resetColumnWidthByName(name);
        }
      });
    }
    this.resetGridViewState();
    this.clearAllFilters();
    this.startLoading("Grouping by columns ".concat((_rollupConfig$columns5 = rollupConfig === null || rollupConfig === void 0 || (_rollupConfig$columns6 = rollupConfig.columns) === null || _rollupConfig$columns6 === void 0 ? void 0 : _rollupConfig$columns6.join(', ')) !== null && _rollupConfig$columns5 !== void 0 ? _rollupConfig$columns5 : '', "..."));
    this.requestSortsChange(EMPTY_ARRAY);

    // Have to clear select distinct since rollup uses the original columns, not the current ones.
    // IrisGridProxyModel has a check to prevent model update
    // when selectDistinctModel is cleared and the rollupConfig is set on the model.
    this.setState({
      rollupConfig,
      movedColumns: EMPTY_ARRAY,
      frozenColumns: EMPTY_ARRAY,
      reverse: false,
      selectDistinctColumns: EMPTY_ARRAY
    });
  }
  handleSelectDistinctChanged(columnNames) {
    log.debug('SelectDistinct change', columnNames);
    this.resetGridViewState();
    this.showAllColumns();
    this.clearAllFilters();
    this.clearAllAggregations();
    this.startLoading("Selecting distinct values in ".concat(columnNames.length > 0 ? columnNames.join(', ') : '', "..."));
    this.requestSortsChange(EMPTY_ARRAY);
    this.setState({
      selectDistinctColumns: columnNames,
      movedColumns: [],
      reverse: false
    });
  }
  handleDownloadTableStart() {
    var canDownloadCsv = this.props.canDownloadCsv;
    if (canDownloadCsv) {
      this.setState({
        isTableDownloading: true,
        tableDownloadProgress: 0,
        tableDownloadEstimatedTime: null,
        tableDownloadStatus: TableCsvExporter.DOWNLOAD_STATUS.INITIATING
      });
    } else {
      log.error('Attempted to handleDownloadTableStart for user without download CSV permission.');
    }
  }
  handleDownloadTable(fileName, frozenTable, tableSubscription, snapshotRanges, modelRanges, includeColumnHeaders, useUnformattedValues) {
    var canDownloadCsv = this.props.canDownloadCsv;
    if (canDownloadCsv) {
      log.info('start table downloading', fileName, frozenTable, tableSubscription, snapshotRanges, modelRanges, includeColumnHeaders, useUnformattedValues);
      this.setState(() => {
        if (this.tableSaver) {
          this.tableSaver.startDownload(fileName, frozenTable, tableSubscription, snapshotRanges, modelRanges, includeColumnHeaders, useUnformattedValues);
        }
        return {
          tableDownloadStatus: TableCsvExporter.DOWNLOAD_STATUS.DOWNLOADING
        };
      });
    } else {
      log.error('Attempted to handleDownloadTable for user without download CSV permission.');
    }
  }

  /**
   * Aggregation editing has completed. Need to filter out any aggregations that have no columns selected
   */
  removeEmptyAggregations() {
    log.debug('removeEmptyAggregations');
    this.setState(_ref25 => {
      var aggregationSettings = _ref25.aggregationSettings;
      var aggregations = aggregationSettings.aggregations;
      var newAggregations = aggregations.filter(a => a.selected.length > 0 || a.invert);
      if (newAggregations.length !== aggregations.length) {
        return {
          selectedAggregation: null,
          aggregationSettings: _objectSpread(_objectSpread({}, aggregationSettings), {}, {
            aggregations: newAggregations
          })
        };
      }
      return {
        selectedAggregation: null,
        aggregationSettings
      };
    });
  }
  seekRow(inputString) {
    var _arguments = arguments,
      _this6 = this;
    return _asyncToGenerator(function* () {
      var _this6$grid;
      var isBackwards = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
      var _this6$state = _this6.state,
        selectedColumnName = _this6$state.gotoValueSelectedColumnName,
        gotoValueSelectedFilter = _this6$state.gotoValueSelectedFilter;
      var model = _this6.props.model;
      var dh = model.dh;
      if (!model.isSeekRowAvailable) {
        return;
      }
      if (inputString === '') {
        return;
      }
      var selectedColumn = IrisGridUtils.getColumnByName(model.columns, selectedColumnName);
      if (selectedColumn === undefined) {
        return;
      }
      var searchFromRow = (_this6$grid = _this6.grid) === null || _this6$grid === void 0 ? void 0 : _this6$grid.state.cursorRow;
      if (searchFromRow == null) {
        searchFromRow = 0;
      }
      var isContains = gotoValueSelectedFilter === FilterType.contains || gotoValueSelectedFilter === FilterType.containsIgnoreCase;
      var isIgnoreCase = gotoValueSelectedFilter === FilterType.eqIgnoreCase || gotoValueSelectedFilter === FilterType.containsIgnoreCase;
      try {
        var _this6$grid2;
        var formatter = model.formatter;
        var columnDataType = TableUtils.getNormalizedType(selectedColumn.type);
        var rowIndex;
        switch (columnDataType) {
          case TableUtils.dataType.CHAR:
          case TableUtils.dataType.STRING:
            {
              rowIndex = yield model.seekRow(searchFromRow, selectedColumn, dh.ValueType.STRING, inputString, isIgnoreCase, isContains, isBackwards !== null && isBackwards !== void 0 ? isBackwards : false);
              break;
            }
          case TableUtils.dataType.DATETIME:
            {
              var _DateUtils$parseDateR = DateUtils.parseDateRange(dh, inputString, formatter.timeZone),
                _DateUtils$parseDateR2 = _slicedToArray(_DateUtils$parseDateR, 1),
                startDate = _DateUtils$parseDateR2[0];
              rowIndex = yield model.seekRow(searchFromRow, selectedColumn, dh.ValueType.DATETIME, startDate, undefined, undefined, isBackwards !== null && isBackwards !== void 0 ? isBackwards : false);
              break;
            }
          case TableUtils.dataType.DECIMAL:
          case TableUtils.dataType.INT:
            {
              if (!TableUtils.isBigDecimalType(selectedColumn.type) && !TableUtils.isBigIntegerType(selectedColumn.type)) {
                var inputValue = parseInt(inputString, 10);
                if (inputString === '-Infinity') {
                  inputValue = Number.NEGATIVE_INFINITY;
                } else if (inputString === 'Infinity') {
                  inputValue = Number.POSITIVE_INFINITY;
                }
                rowIndex = yield model.seekRow(searchFromRow, selectedColumn, dh.ValueType.NUMBER, inputValue, undefined, undefined, isBackwards !== null && isBackwards !== void 0 ? isBackwards : false);
              } else {
                rowIndex = yield model.seekRow(searchFromRow, selectedColumn, dh.ValueType.STRING, inputString, undefined, undefined, isBackwards !== null && isBackwards !== void 0 ? isBackwards : false);
              }
              break;
            }
          default:
            {
              rowIndex = yield model.seekRow(searchFromRow, selectedColumn, dh.ValueType.STRING, _this6.tableUtils.makeValue(selectedColumn.type, inputString, formatter.timeZone), undefined, undefined, isBackwards !== null && isBackwards !== void 0 ? isBackwards : false);
            }
        }
        (_this6$grid2 = _this6.grid) === null || _this6$grid2 === void 0 || _this6$grid2.setFocusRow(rowIndex);
        _this6.setState({
          gotoValueError: ''
        });
      } catch (e) {
        _this6.setState({
          gotoValueError: 'invalid input'
        });
      }
    })();
  }
  handleCancelDownloadTable() {
    var _this$tableSaver;
    (_this$tableSaver = this.tableSaver) === null || _this$tableSaver === void 0 || _this$tableSaver.cancelDownload();
    this.setState({
      isTableDownloading: false
    });
  }
  handleDownloadCompleted() {
    this.setState({
      isTableDownloading: false,
      tableDownloadProgress: 100,
      tableDownloadStatus: TableCsvExporter.DOWNLOAD_STATUS.FINISHED
    });
  }
  handleDownloadCanceled() {
    this.setState({
      isTableDownloading: false,
      tableDownloadProgress: 0,
      tableDownloadStatus: TableCsvExporter.DOWNLOAD_STATUS.CANCELED
    });
  }

  /**
   * Delete the specified ranges from the table.
   * @param ranges The ranges to delete
   */
  deleteRanges(ranges) {
    var model = this.props.model;
    if (!isDeletableGridModel(model) || !model.isDeletable) {
      throw new Error('Model does not support deleting ranges');
    }
    this.pending.add(model.delete(ranges)).catch(e => {
      if (!PromiseUtils.isCanceled(e)) {
        log.error('Unable to delete ranges', ranges, e);
      }
    });
  }
  resetColumnSelection() {
    if (this.grid == null) {
      return;
    }
    var isSelectingColumn = this.props.isSelectingColumn;
    if (isSelectingColumn) {
      var columnAllowedCursor = this.props.columnAllowedCursor;
      this.grid.setState({
        cursor: columnAllowedCursor
      });
    } else {
      this.grid.setState({
        cursor: null
      });
      this.setState({
        hoverSelectColumn: null
      });
    }
  }
  resetGridViewState() {
    var forceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!this.grid) {
      return;
    }
    this.grid.clearSelectedRanges();
    this.grid.setViewState({
      left: 0,
      top: 0,
      topOffset: 0,
      leftOffset: 0
    }, forceUpdate);
  }
  sendStateChange() {
    if (!this.grid) {
      return;
    }
    var irisGridState = this.state;
    var gridState = this.grid.state;
    var onStateChange = this.props.onStateChange;
    onStateChange(irisGridState, gridState);
  }
  handleOverflowClose() {
    var _this$grid23;
    this.setState({
      showOverflowModal: false
    });
    (_this$grid23 = this.grid) === null || _this$grid23 === void 0 || _this$grid23.focus(); // Focus on the grid after closing the overflow modal
  }
  handleOpenNoPastePermissionModal(errorMessage) {
    this.setState({
      showNoPastePermissionModal: true,
      noPastePermissionError: errorMessage
    });
  }
  handleCloseNoPastePermissionModal() {
    this.setState({
      showNoPastePermissionModal: false
    });
  }
  getColumnBoundingRect() {
    var _this$gridWrapper2;
    var _this$state20 = this.state,
      metrics = _this$state20.metrics,
      shownColumnTooltip = _this$state20.shownColumnTooltip;
    assertNotNull(metrics);
    assertNotNull(shownColumnTooltip);
    var gridRect = (_this$gridWrapper2 = this.gridWrapper) === null || _this$gridWrapper2 === void 0 ? void 0 : _this$gridWrapper2.getBoundingClientRect();
    var popperMargin = 20;
    assertNotNull(gridRect);
    var columnHeaderHeight = metrics.columnHeaderHeight,
      allColumnXs = metrics.allColumnXs,
      allColumnWidths = metrics.allColumnWidths,
      width = metrics.width,
      columnHeaderMaxDepth = metrics.columnHeaderMaxDepth;
    var columnX = allColumnXs.get(shownColumnTooltip);
    var columnWidth = allColumnWidths.get(shownColumnTooltip);
    assertNotNull(columnX);
    assertNotNull(columnWidth);
    var left = gridRect.left + clamp(columnX + columnWidth / 2, popperMargin, width - popperMargin);
    return {
      top: gridRect.top + (columnHeaderMaxDepth - 1) * columnHeaderHeight,
      left: gridRect.left + clamp(columnX + columnWidth / 2, popperMargin, width - popperMargin),
      bottom: gridRect.top + columnHeaderMaxDepth * columnHeaderHeight,
      right: gridRect.left + clamp(columnX + columnWidth / 2, popperMargin, width - popperMargin) + 1,
      width: 1,
      height: columnHeaderHeight,
      x: left,
      y: gridRect.top,
      toJSON: () => {
        throw new Error('not implemented');
      }
    };
  }
  handleGotoRowSelectedRowNumberSubmit() {
    var rowNumber = this.state.gotoRow;
    this.focusRowInGrid(rowNumber);
  }
  focusRowInGrid(rowNumber) {
    var model = this.props.model;
    var rowCount = model.rowCount;
    this.setState({
      gotoRow: rowNumber
    });
    if (rowNumber === '') {
      this.setState({
        gotoRowError: '',
        gotoValueError: ''
      });
      return;
    }
    var rowInt = parseInt(rowNumber, 10);
    if (rowInt > rowCount || rowInt < -rowCount) {
      this.setState({
        gotoRowError: 'Invalid row index'
      });
    } else if (rowInt === 0) {
      var _this$grid24;
      this.setState({
        gotoRowError: '',
        gotoValueError: ''
      });
      (_this$grid24 = this.grid) === null || _this$grid24 === void 0 || _this$grid24.setFocusRow(0);
    } else if (rowInt < 0) {
      var _this$grid25;
      this.setState({
        gotoRowError: '',
        gotoValueError: ''
      });
      (_this$grid25 = this.grid) === null || _this$grid25 === void 0 || _this$grid25.setFocusRow(rowInt + rowCount);
    } else {
      var _this$grid26;
      (_this$grid26 = this.grid) === null || _this$grid26 === void 0 || _this$grid26.setFocusRow(rowInt - 1);
      this.setState({
        gotoRowError: '',
        gotoValueError: ''
      });
    }
  }
  handleGotoRowSelectedRowNumberChanged(event) {
    var rowNumber = event.target.value;
    this.focusRowInGrid(rowNumber);
  }
  getColumnTooltip(visibleIndex, metrics, model) {
    var columnHeaderHeight = metrics.columnHeaderHeight,
      columnHeaderMaxDepth = metrics.columnHeaderMaxDepth,
      allColumnXs = metrics.allColumnXs,
      allColumnWidths = metrics.allColumnWidths,
      width = metrics.width;
    var columnX = allColumnXs.get(visibleIndex);
    var columnWidth = allColumnWidths.get(visibleIndex);
    if (columnX == null || columnWidth == null) {
      return null;
    }

    /**
     * Create a wrapper dom element, the size of the column header.
     * The wrapper acts as tooltip parent, the  tooltip component
     * will trigger hide on mouseleave of wrapper or tooltip.
     * The wrapper should be bound to within the grid dimensions,
     * so popper only remains triggered while mouse is inside the panel.
     */
    var boundedLeft = Math.max(0, columnX);
    var boundedWidth = columnWidth;
    if (columnX + columnWidth > width) {
      // column is extending past right edge
      boundedWidth = width - columnX;
    } else if (columnX < 0) {
      // column is extending past left edge
      boundedWidth = columnWidth - Math.abs(columnX);
    }
    var wrapperStyle = {
      position: 'absolute',
      top: (columnHeaderMaxDepth - 1) * columnHeaderHeight,
      left: boundedLeft,
      width: boundedWidth,
      height: columnHeaderHeight,
      pointerEvents: 'none'
    };

    /**
     * Because the popper parent wrapper center is no longer the same as
     * the column label center, we create a popper virtual ref, to handle
     * positioning and keep the popper centered on the label. Creates a
     * 1px x headerHeight virtual object, placed centered on the column
     * label, clamped to 0 + margin to width - margin. We add a margin,
     * otherwise the arrow wants to escape the boundary.
     */
    var virtualReference = {
      clientWidth: 1,
      clientHeight: columnHeaderHeight,
      getBoundingClientRect: this.getColumnBoundingRect
    };
    var popperOptions = {
      placement: 'bottom',
      modifiers: {
        flip: {
          behavior: ['bottom', 'top']
        }
      }
    };
    var modelColumn = this.getModelColumn(visibleIndex);
    if (modelColumn == null) return null;
    var column = model.columns[modelColumn];
    if (column == null) return null;
    return /*#__PURE__*/_jsx("div", {
      style: wrapperStyle,
      children: /*#__PURE__*/_jsx(Tooltip, {
        timeout: 400,
        interactive: true,
        options: popperOptions,
        ref: this.handleTooltipRef,
        referenceObject: virtualReference,
        onExited: () => {
          this.setState({
            shownColumnTooltip: null
          });
        },
        children: /*#__PURE__*/_jsx(ColumnStatistics, {
          model: model,
          column: column,
          onStatistics: () => {
            var _this$tooltip;
            (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 || _this$tooltip.update();
          }
        })
      }, column.name)
    });
  }
  handleGotoValueSelectedColumnNameChanged(columnName) {
    var _this$grid27;
    var model = this.props.model;
    var cursorRow = (_this$grid27 = this.grid) === null || _this$grid27 === void 0 ? void 0 : _this$grid27.state.cursorRow;
    var _this$state21 = this.state,
      prevColumnName = _this$state21.gotoValueSelectedColumnName,
      gotoValueManuallyChanged = _this$state21.gotoValueManuallyChanged;
    if (cursorRow != null) {
      var index = model.getColumnIndexByName(columnName);
      var column = IrisGridUtils.getColumnByName(model.columns, columnName);
      var prevColumn = IrisGridUtils.getColumnByName(model.columns, prevColumnName);
      if (index == null || column == null) {
        return;
      }
      var value = model.valueForCell(index, cursorRow);
      var text = IrisGridUtils.convertValueToText(value, column.type);

      // do NOT update value if user manually changed value AND column type remains the same
      if (gotoValueManuallyChanged && column.type === (prevColumn === null || prevColumn === void 0 ? void 0 : prevColumn.type)) {
        this.setState({
          gotoValueSelectedColumnName: columnName,
          gotoValueError: ''
        });
      } else {
        // do update, and set goToValueManuallyChanged to false because value was automatically changed
        this.setState({
          gotoValueSelectedColumnName: columnName,
          gotoValue: text,
          gotoValueError: '',
          gotoValueManuallyChanged: false
        });
      }
    }
    this.setState({
      gotoValueSelectedColumnName: columnName,
      gotoValueError: ''
    });
  }
  handleGotoValueSelectedFilterChanged(value) {
    this.setState({
      gotoValueSelectedFilter: value,
      gotoValueError: ''
    });
  }
  handleGotoValueSubmitted(isBackwards) {
    var gotoValue = this.state.gotoValue;
    this.seekRow(gotoValue, isBackwards);
  }

  /**
   * Render the input field for the focused filter
   * @param metrics Grid metrics
   * @param metricCalculator Metric calculator
   * @param focusedFilterBarColumn Column index for the focused filter
   * @param quickFilters Quick filters map
   * @param advancedFilters Advanced filters map
   * @returns The filter input field element or null if not applicable
   */
  getFilterBarInput(metrics, metricCalculator, focusedFilterBarColumn, quickFilters, advancedFilters) {
    var _this$grid28;
    if (metrics == null || focusedFilterBarColumn == null) {
      return null;
    }
    var metricState = this.getMetricState();
    if (metricState == null) {
      return null;
    }
    var filterBoxCoordinates = metricCalculator.getFilterInputCoordinates(focusedFilterBarColumn, metricState, metrics);
    if (filterBoxCoordinates == null) {
      return null;
    }
    var debounceMs = Math.min(Math.max(IrisGrid.minDebounce, Math.round(metrics.rowCount / 200)), IrisGrid.maxDebounce);
    var x = filterBoxCoordinates.x,
      y = filterBoxCoordinates.y,
      fieldWidth = filterBoxCoordinates.width,
      fieldHeight = filterBoxCoordinates.height;
    var width = metrics.width;
    var style = {
      top: y,
      left: x,
      minWidth: Math.min(fieldWidth, width - x),
      // Don't cause overflow
      height: fieldHeight
    };
    var value = '';
    var isValid = true;
    var modelColumn = this.getModelColumn(focusedFilterBarColumn);
    assertNotNull(modelColumn);
    var quickFilter = quickFilters.get(modelColumn);
    var advancedFilter = advancedFilters.get(modelColumn);
    if (quickFilter != null) {
      value = quickFilter.text;
      isValid = quickFilter.filter != null;
    }
    var isBarFiltered = quickFilters.size !== 0 || advancedFilters.size !== 0;
    var showAdvancedFilterButton = metricCalculator.getAdvancedFilterButtonCoordinates(focusedFilterBarColumn, metricState, metrics) != null;
    return /*#__PURE__*/_jsx(FilterInputField, {
      ref: this.filterInputRef,
      style: style,
      className: classNames({
        error: !isValid,
        active: value !== '' || advancedFilter != null,
        'iris-grid-has-filter': isBarFiltered
      }),
      showAdvancedFilterButton: showAdvancedFilterButton,
      isAdvancedFilterSet: advancedFilter != null,
      onAdvancedFiltersTriggered: () => {
        this.setState({
          shownAdvancedFilter: focusedFilterBarColumn
        });
      },
      onChange: this.handleFilterBarChange,
      onDone: this.handleFilterBarDone,
      onTab: this.handleFilterBarTab,
      onContextMenu: (_this$grid28 = this.grid) === null || _this$grid28 === void 0 ? void 0 : _this$grid28.handleContextMenu,
      debounceMs: debounceMs,
      value: value
    }, focusedFilterBarColumn);
  }
  render() {
    var _rollupConfig$columns7,
      _rollupConfig$columns8,
      _this7 = this,
      _this$grid29,
      _openOptions;
    var _this$props0 = this.props,
      children = _this$props0.children,
      customFilters = _this$props0.customFilters,
      getDownloadWorker = _this$props0.getDownloadWorker,
      isSelectingColumn = _this$props0.isSelectingColumn,
      isStuckToBottom = _this$props0.isStuckToBottom,
      isStuckToRight = _this$props0.isStuckToRight,
      model = _this$props0.model,
      name = _this$props0.name,
      onlyFetchVisibleColumns = _this$props0.onlyFetchVisibleColumns,
      alwaysFetchColumns = _this$props0.alwaysFetchColumns,
      advancedSettings = _this$props0.advancedSettings,
      onAdvancedSettingsChange = _this$props0.onAdvancedSettingsChange,
      canDownloadCsv = _this$props0.canDownloadCsv,
      onCreateChart = _this$props0.onCreateChart,
      transformTableOptions = _this$props0.transformTableOptions;
    var cellInputRendererRegistry = this.context.cellInputRendererRegistry;
    var _this$state22 = this.state,
      metricCalculator = _this$state22.metricCalculator,
      metrics = _this$state22.metrics,
      isFilterBarShown = _this$state22.isFilterBarShown,
      isSelectingPartition = _this$state22.isSelectingPartition,
      isMenuShown = _this$state22.isMenuShown,
      isReady = _this$state22.isReady,
      copyOperation = _this$state22.copyOperation,
      focusedFilterBarColumn = _this$state22.focusedFilterBarColumn,
      loadingText = _this$state22.loadingText,
      loadingScrimProgress = _this$state22.loadingScrimProgress,
      loadingSpinnerShown = _this$state22.loadingSpinnerShown,
      loadingCancelShown = _this$state22.loadingCancelShown,
      loadingBlocksGrid = _this$state22.loadingBlocksGrid,
      shownColumnTooltip = _this$state22.shownColumnTooltip,
      hoverAdvancedFilter = _this$state22.hoverAdvancedFilter,
      shownAdvancedFilter = _this$state22.shownAdvancedFilter,
      maximizedAdvancedFilter = _this$state22.maximizedAdvancedFilter,
      hoverSelectColumn = _this$state22.hoverSelectColumn,
      quickFilters = _this$state22.quickFilters,
      advancedFilters = _this$state22.advancedFilters,
      searchFilter = _this$state22.searchFilter,
      selectDistinctColumns = _this$state22.selectDistinctColumns,
      movedColumns = _this$state22.movedColumns,
      movedRows = _this$state22.movedRows,
      formatter = _this$state22.formatter,
      conditionalFormats = _this$state22.conditionalFormats,
      conditionalFormatPreview = _this$state22.conditionalFormatPreview,
      conditionalFormatEditIndex = _this$state22.conditionalFormatEditIndex,
      conditionalFormatError = _this$state22.conditionalFormatError,
      columnAlignmentMap = _this$state22.columnAlignmentMap,
      sorts = _this$state22.sorts,
      reverse = _this$state22.reverse,
      customColumns = _this$state22.customColumns,
      selectedRanges = _this$state22.selectedRanges,
      isTableDownloading = _this$state22.isTableDownloading,
      tableDownloadStatus = _this$state22.tableDownloadStatus,
      tableDownloadProgress = _this$state22.tableDownloadProgress,
      tableDownloadEstimatedTime = _this$state22.tableDownloadEstimatedTime,
      showSearchBar = _this$state22.showSearchBar,
      searchValue = _this$state22.searchValue,
      selectedSearchColumns = _this$state22.selectedSearchColumns,
      invertSearchColumns = _this$state22.invertSearchColumns,
      aggregationSettings = _this$state22.aggregationSettings,
      selectedAggregation = _this$state22.selectedAggregation,
      rollupConfig = _this$state22.rollupConfig,
      openOptions = _this$state22.openOptions,
      pendingSavePromise = _this$state22.pendingSavePromise,
      pendingSaveError = _this$state22.pendingSaveError,
      pendingRowCount = _this$state22.pendingRowCount,
      pendingDataErrors = _this$state22.pendingDataErrors,
      pendingDataMap = _this$state22.pendingDataMap,
      toastMessage = _this$state22.toastMessage,
      frozenColumns = _this$state22.frozenColumns,
      columnHeaderGroups = _this$state22.columnHeaderGroups,
      showOverflowModal = _this$state22.showOverflowModal,
      showNoPastePermissionModal = _this$state22.showNoPastePermissionModal,
      noPastePermissionError = _this$state22.noPastePermissionError,
      overflowText = _this$state22.overflowText,
      overflowButtonTooltipProps = _this$state22.overflowButtonTooltipProps,
      expandCellTooltipProps = _this$state22.expandCellTooltipProps,
      hoverTooltipProps = _this$state22.hoverTooltipProps,
      isGotoShown = _this$state22.isGotoShown,
      gotoRow = _this$state22.gotoRow,
      gotoRowError = _this$state22.gotoRowError,
      gotoValueError = _this$state22.gotoValueError,
      gotoValueSelectedColumnName = _this$state22.gotoValueSelectedColumnName,
      gotoValue = _this$state22.gotoValue,
      gotoValueSelectedFilter = _this$state22.gotoValueSelectedFilter,
      partitionConfig = _this$state22.partitionConfig;
    if (!isReady) {
      return null;
    }
    var theme = this.getTheme();
    var singleColumnHeaderHeight = theme.columnHeaderHeight;
    var filter = this.getCachedFilter(customFilters, quickFilters, advancedFilters, searchFilter);
    var userColumnWidths = metricCalculator.getUserColumnWidths();
    var stateOverride = this.getCachedStateOverride(model, theme, hoverSelectColumn, isFilterBarShown, isSelectingColumn, loadingScrimProgress, quickFilters, advancedFilters, sorts, reverse, rollupConfig, isMenuShown);
    var top = metrics ? metrics.top : 0;
    var bottom = metrics ? metrics.bottomViewport : 0;
    var left = null;
    var right = null;
    if (onlyFetchVisibleColumns) {
      left = metrics ? metrics.left : 0;
      right = metrics ? metrics.right : 0;
    }
    var isVisible = metrics != null && metrics.width > 0 && metrics.height > 0;
    var isRollup = ((_rollupConfig$columns7 = rollupConfig === null || rollupConfig === void 0 || (_rollupConfig$columns8 = rollupConfig.columns) === null || _rollupConfig$columns8 === void 0 ? void 0 : _rollupConfig$columns8.length) !== null && _rollupConfig$columns7 !== void 0 ? _rollupConfig$columns7 : 0) > 0;
    var focusField = isFilterBarShown ? this.getFilterBarInput(metrics, metricCalculator, focusedFilterBarColumn, quickFilters, advancedFilters) : null;
    var loadingElement = null;
    if (loadingText != null) {
      var loadingStatus = /*#__PURE__*/_jsxs("div", {
        className: "iris-grid-loading-status",
        children: [/*#__PURE__*/_jsx("div", {
          className: classNames('iris-grid-loading-status-bar', {
            show: loadingSpinnerShown
          }),
          children: loadingText
        }), /*#__PURE__*/_jsxs("button", {
          type: "button",
          onClick: this.handleCancel,
          className: classNames('iris-grid-btn-cancel', {
            show: loadingCancelShown
          }),
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsClose,
            transform: "down-1"
          }), "Cancel"]
        })]
      });
      var gridY = metrics ? metrics.gridY : 0;
      loadingElement = /*#__PURE__*/_jsx("div", {
        className: "iris-grid-loading",
        style: loadingBlocksGrid ? {
          top: gridY
        } : {},
        children: loadingStatus
      });
    }
    var columnTooltip = null;
    if (shownColumnTooltip != null && metrics) {
      var _this$tooltip2;
      columnTooltip = this.getColumnTooltip(shownColumnTooltip, metrics, model);
      // #510 We may need to update the position of the tooltip if it's already opened and columns are resized
      (_this$tooltip2 = this.tooltip) === null || _this$tooltip2 === void 0 || _this$tooltip2.update();
    }
    var filterBar = [];
    if (metrics && isFilterBarShown) {
      var metricState = this.getMetricState();

      // Advanced Filter buttons
      var visibleColumns = metrics.visibleColumns;
      var _loop2 = function _loop2() {
        var columnIndex = visibleColumns[i];
        var modelColumn = _this7.getModelColumn(columnIndex);
        if (modelColumn != null) {
          var isFilterable = model.isFilterable(modelColumn);
          var buttonCoordinates = isFilterable && metricState ? metricCalculator.getAdvancedFilterButtonCoordinates(columnIndex, metricState, metrics) : null;
          if (buttonCoordinates != null) {
            var x = buttonCoordinates.x,
              y = buttonCoordinates.y;
            var style = {
              position: 'absolute',
              top: y,
              left: x
            };
            var advancedFilter = advancedFilters.get(modelColumn);
            var isFilterSet = advancedFilter != null;
            var isFilterVisible = columnIndex === hoverAdvancedFilter || columnIndex === focusedFilterBarColumn || isFilterSet;
            var element = /*#__PURE__*/_jsx("div", {
              className: classNames('advanced-filter-button-container', {
                hidden: !isFilterVisible
              }),
              style: style,
              children: isFilterVisible && /*#__PURE__*/_jsx(Button, {
                kind: "ghost",
                className: classNames('btn-link-icon advanced-filter-button', {
                  'filter-set': isFilterSet
                }),
                onClick: () => {
                  _this7.setState({
                    shownAdvancedFilter: columnIndex,
                    maximizedAdvancedFilter: null
                  });
                },
                onContextMenu: event => {
                  var _this7$grid;
                  (_this7$grid = _this7.grid) === null || _this7$grid === void 0 || _this7$grid.handleContextMenu(event);
                },
                onMouseEnter: () => {
                  _this7.setState({
                    hoverAdvancedFilter: columnIndex
                  });
                },
                onMouseLeave: () => {
                  _this7.setState({
                    hoverAdvancedFilter: null
                  });
                },
                children: /*#__PURE__*/_jsxs("div", {
                  className: "fa-layers",
                  children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: dhFilterFilled,
                    className: "filter-solid"
                  }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: vsFilter,
                    className: "filter-light"
                  })]
                })
              })
            }, columnIndex);
            filterBar.push(element);
          }
        }
      };
      for (var i = 0; i < visibleColumns.length; i += 1) {
        _loop2();
      }
    }
    var advancedFilterMenus = [];
    if (metrics) {
      var gridX = metrics.gridX,
        _visibleColumns = metrics.visibleColumns,
        allColumnXs = metrics.allColumnXs,
        allColumnWidths = metrics.allColumnWidths,
        columnHeaderHeight = metrics.columnHeaderHeight;
      var _loop3 = function _loop3() {
        var columnIndex = _visibleColumns[_i4];
        var columnX = allColumnXs.get(columnIndex);
        var columnWidth = allColumnWidths.get(columnIndex);
        if (columnX != null && columnWidth != null && columnWidth > 0) {
          var xColumnHeader = gridX + columnX;
          var xFilterBar = gridX + columnX + columnWidth - 20;
          var style = isFilterBarShown ? {
            position: 'absolute',
            top: columnHeaderHeight,
            left: xFilterBar,
            width: 20,
            height: theme.filterBarHeight
          } : {
            position: 'absolute',
            top: 0,
            left: xColumnHeader,
            width: columnWidth,
            height: columnHeaderHeight
          };
          var modelColumn = _this7.getModelColumn(columnIndex);
          if (modelColumn != null) {
            var column = model.columns[modelColumn];
            if (column == null) {
              // Grid metrics is likely out of sync with model
              log.warn("Column does not exist at index ".concat(modelColumn, " for column array of length ").concat(model.columns.length));
              // eslint-disable-next-line no-continue
              return 1; // continue
            }
            var advancedFilter = advancedFilters.get(modelColumn);
            var _ref26 = advancedFilter || {},
              advancedFilterOptions = _ref26.options;
            var sort = TableUtils.getSortForColumn(model.sort, column.name);
            var sortDirection = sort ? sort.direction : null;
            if (!isSortDirection(sortDirection)) {
              throw new Error("Invalid sort direction: ".concat(sortDirection));
            }
            var element = /*#__PURE__*/_jsx("div", {
              className: "advanced-filter-menu-container",
              style: style,
              children: /*#__PURE__*/_jsx(Popper, {
                className: "advanced-filter-menu-popper",
                isMaximized: shownAdvancedFilter === columnIndex && maximizedAdvancedFilter === columnIndex,
                onEntered: _this7.getAdvancedMenuOpenedHandler(columnIndex),
                onExited: () => {
                  _this7.handleAdvancedMenuClosed(columnIndex);
                },
                isShown: shownAdvancedFilter === columnIndex,
                interactive: true,
                closeOnBlur: true,
                options: {
                  positionFixed: true
                },
                children: _this7.getCachedAdvancedFilterMenuActions(model, column, advancedFilterOptions, sortDirection, formatter, shownAdvancedFilter === columnIndex && maximizedAdvancedFilter === columnIndex, _this7.getAdvancedMenuToggleMaximizeHandler(columnIndex))
              })
            }, columnIndex);
            advancedFilterMenus.push(element);
          }
        }
      };
      for (var _i4 = 0; _i4 < _visibleColumns.length; _i4 += 1) {
        if (_loop3()) continue;
      }
    }
    var defaultOptionItems = this.getCachedOptionItems(onCreateChart !== undefined && model.isChartBuilderAvailable, model.isCustomColumnsAvailable, model.isFormatColumnsAvailable, model.isOrganizeColumnsAvailable, model.isRollupAvailable, model.isTotalsAvailable || isRollup, model.isSelectDistinctAvailable, model.isExportAvailable, this.toggleFilterBarAction, this.toggleSearchBarAction, this.toggleGotoRowAction, isFilterBarShown, showSearchBar, canDownloadCsv, this.isTableSearchAvailable(), isGotoShown, advancedSettings.size > 0);
    var optionItems = this.getCachedTransformedOptionItems(defaultOptionItems, transformTableOptions);
    var hiddenColumns = this.getCachedHiddenColumns(metricCalculator, userColumnWidths);
    var openOptionsStack = openOptions.map(option => {
      switch (option.type) {
        case OptionType.CHART_BUILDER:
          return /*#__PURE__*/_jsx(ChartBuilder, {
            model: model,
            onChange: this.handleChartChange,
            onSubmit: this.handleChartCreate
          }, OptionType.CHART_BUILDER);
        case OptionType.VISIBILITY_ORDERING_BUILDER:
          return /*#__PURE__*/_jsx(VisibilityOrderingBuilder, {
            model: model,
            movedColumns: movedColumns,
            hiddenColumns: hiddenColumns,
            columnHeaderGroups: columnHeaderGroups,
            onColumnVisibilityChanged: this.handleColumnVisibilityChanged,
            onReset: this.handleColumnVisibilityReset,
            onMovedColumnsChanged: this.handleMovedColumnsChanged,
            onColumnHeaderGroupChanged: this.handleHeaderGroupsChanged,
            onFrozenColumnsChanged: this.handleFrozenColumnsChanged
          }, OptionType.VISIBILITY_ORDERING_BUILDER);
        case OptionType.CONDITIONAL_FORMATTING:
          return /*#__PURE__*/_jsx(ConditionalFormattingMenu, {
            rules: conditionalFormats,
            onChange: this.handleConditionalFormatsChange,
            onCreate: this.handleConditionalFormatCreate,
            onSelect: this.handleConditionalFormatEdit
          });
        case OptionType.CONDITIONAL_FORMATTING_EDIT:
          assertNotNull(model.columns);
          assertNotNull(this.handleConditionalFormatEditorUpdate);
          return /*#__PURE__*/_jsx(ConditionalFormatEditor, {
            dh: model.dh,
            columns: model.columns,
            rule: conditionalFormatPreview,
            errorMessage: conditionalFormatError !== null && conditionalFormatError !== void 0 ? conditionalFormatError : undefined,
            onUpdate: this.handleConditionalFormatEditorUpdate,
            onSave: this.handleConditionalFormatEditorSave,
            onCancel: this.handleConditionalFormatEditorCancel
          });
        case OptionType.CUSTOM_COLUMN_BUILDER:
          return /*#__PURE__*/_jsx(CustomColumnBuilder, {
            model: model,
            customColumns: customColumns,
            onSave: this.handleUpdateCustomColumns,
            onCancel: this.handleMenuBack
          }, OptionType.CUSTOM_COLUMN_BUILDER);
        case OptionType.ROLLUP_ROWS:
          return /*#__PURE__*/_jsx(RollupRows, {
            model: model,
            onChange: this.handleRollupChange,
            config: rollupConfig
          }, OptionType.ROLLUP_ROWS);
        case OptionType.AGGREGATIONS:
          return /*#__PURE__*/_jsx(Aggregations, {
            settings: aggregationSettings,
            isRollup: isRollup,
            availablePlacements: isEditableGridModel(model) && model.isEditable ? ['top'] : ['top', 'bottom'],
            onChange: this.handleAggregationsChange,
            onEdit: this.handleAggregationEdit,
            dh: model.dh
          });
        case OptionType.AGGREGATION_EDIT:
          return selectedAggregation && /*#__PURE__*/_jsx(AggregationEdit, {
            aggregation: selectedAggregation,
            columns: model.originalColumns,
            onChange: this.handleAggregationChange
          });
        case OptionType.TABLE_EXPORTER:
          return /*#__PURE__*/_jsx(TableCsvExporter, {
            model: model,
            name: name,
            userColumnWidths: userColumnWidths,
            movedColumns: movedColumns,
            isDownloading: isTableDownloading,
            tableDownloadStatus: tableDownloadStatus,
            tableDownloadProgress: tableDownloadProgress,
            tableDownloadEstimatedTime: tableDownloadEstimatedTime !== null && tableDownloadEstimatedTime !== void 0 ? tableDownloadEstimatedTime : undefined,
            onDownload: this.handleDownloadTable,
            onDownloadStart: this.handleDownloadTableStart,
            onCancel: this.handleCancelDownloadTable,
            selectedRanges: selectedRanges
          }, OptionType.TABLE_EXPORTER);
        case OptionType.SELECT_DISTINCT:
          return /*#__PURE__*/_jsx(SelectDistinctBuilder, {
            model: model,
            selectDistinctColumns: selectDistinctColumns,
            onChange: this.handleSelectDistinctChanged
          });
        case OptionType.ADVANCED_SETTINGS:
          return /*#__PURE__*/_jsx(AdvancedSettingsMenu, {
            items: advancedSettings,
            onChange: onAdvancedSettingsChange
          });
        default:
          {
            // Plugin-contributed items render their own page via
            // `configPage`. The page is isolated inside an error
            // boundary so a throwing plugin doesn't tear down the
            // entire grid subtree. Built-in items that hit the default
            // case indicate a programmer error (unhandled enum case).
            var PluginPage = option.configPage;
            if (PluginPage == null) {
              throw Error("Unexpected option type ".concat(option.type));
            }
            return /*#__PURE__*/_jsx(PluginTableOptionsErrorBoundary, {
              itemType: String(option.type),
              children: /*#__PURE__*/_jsx(PluginPage, {
                model: model,
                viewState: this.getCachedViewState(this.getCachedHiddenColumnNames(hiddenColumns, model.columns)),
                onBack: this.handleMenuBack
              })
            }, String(option.type));
          }
      }
    });
    return /*#__PURE__*/_jsxs("div", {
      className: "iris-grid",
      role: "presentation",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "iris-grid-column",
        children: [children != null && /*#__PURE__*/_jsx("div", {
          className: "iris-grid-bar",
          children: children
        }), /*#__PURE__*/_jsx(CSSTransition, {
          in: isSelectingPartition,
          timeout: ThemeExport.transitionSlowMs,
          classNames: "iris-grid-bar-horizontal",
          onEnter: this.handleAnimationStart,
          onEntered: this.handleAnimationEnd,
          onExit: this.handleAnimationStart,
          onExited: this.handleAnimationEnd,
          mountOnEnter: true,
          unmountOnExit: true,
          nodeRef: this.slideTransitionRef,
          children: /*#__PURE__*/_jsx("div", {
            ref: this.slideTransitionRef,
            className: "iris-grid-partition-selector-wrapper iris-grid-bar iris-grid-bar-primary",
            children: isPartitionedGridModel(model) && model.isPartitionRequired && /*#__PURE__*/_jsx(IrisGridPartitionSelector, {
              model: model,
              partitionConfig: partitionConfig,
              onChange: this.handlePartitionChange
            })
          })
        }), /*#__PURE__*/_jsx(CSSTransition, {
          in: showSearchBar,
          timeout: ThemeExport.transitionSlowMs,
          classNames: "iris-grid-bar-horizontal",
          onEnter: this.handleAnimationStart,
          onEntered: this.handleAnimationEnd,
          onExit: this.handleAnimationStart,
          onExited: this.handleAnimationEnd,
          mountOnEnter: true,
          unmountOnExit: true,
          nodeRef: this.bottomTransitionRef,
          children: /*#__PURE__*/_jsx("div", {
            ref: this.bottomTransitionRef,
            className: "iris-grid-bar",
            children: /*#__PURE__*/_jsx(CrossColumnSearch, {
              value: searchValue,
              selectedColumns: selectedSearchColumns,
              invertSelection: invertSearchColumns,
              onChange: this.handleCrossColumnSearch,
              columns: model.columns,
              ref: this.crossColumnRef
            })
          })
        }), /*#__PURE__*/_jsxs(Grid, {
          ref: grid => {
            this.grid = grid;
          },
          isStickyBottom: !isEditableGridModel(model) || !model.isEditable,
          isStuckToBottom: isStuckToBottom,
          isStuckToRight: isStuckToRight,
          metricCalculator: metricCalculator,
          model: model,
          keyHandlers: this.getKeyHandlers(),
          mouseHandlers: this.getMouseHandlers(),
          movedColumns: movedColumns,
          movedRows: movedRows,
          onError: this.handleGridError,
          onViewChanged: this.handleViewChanged,
          onSelectionChanged: this.handleSelectionChanged,
          onMovedColumnsChanged: this.handleMovedColumnsChanged,
          renderer: this.renderer,
          cellInputRendererRegistry: cellInputRendererRegistry !== null && cellInputRendererRegistry !== void 0 ? cellInputRendererRegistry : DEFAULT_REGISTRY,
          stateOverride: stateOverride,
          theme: theme,
          children: [/*#__PURE__*/_jsx(IrisGridCellOverflowModal, {
            isOpen: showOverflowModal,
            text: overflowText,
            onClose: this.handleOverflowClose
          }), isVisible && /*#__PURE__*/_jsx(IrisGridModelUpdater, {
            model: model,
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            filter: filter,
            formatter: formatter,
            columnAlignmentMap: columnAlignmentMap,
            sorts: sorts,
            reverse: reverse,
            movedColumns: movedColumns,
            customColumns: customColumns,
            hiddenColumns: hiddenColumns,
            alwaysFetchColumns: this.getAlwaysFetchColumns(alwaysFetchColumns, model.columns, movedColumns, model.floatingLeftColumnCount, model.floatingRightColumnCount, (_this$grid29 = this.grid) === null || _this$grid29 === void 0 || (_this$grid29 = _this$grid29.state.draggingColumn) === null || _this$grid29 === void 0 ? void 0 : _this$grid29.range),
            formatColumns: this.getCachedPreviewFormatColumns(model.dh, model.columns, conditionalFormats, conditionalFormatPreview,
            // Disable the preview format when we press Back on the format edit page
            ((_openOptions = openOptions[openOptions.length - 1]) === null || _openOptions === void 0 ? void 0 : _openOptions.type) === OptionType.CONDITIONAL_FORMATTING_EDIT ? conditionalFormatEditIndex !== null && conditionalFormatEditIndex !== void 0 ? conditionalFormatEditIndex : undefined : undefined),
            rollupConfig: this.getModelRollupConfig(model.originalColumns, rollupConfig, aggregationSettings),
            totalsConfig: this.getModelTotalsConfig(model.columns, rollupConfig, aggregationSettings),
            selectDistinctColumns: selectDistinctColumns,
            pendingRowCount: pendingRowCount,
            pendingDataMap: pendingDataMap,
            frozenColumns: frozenColumns,
            columnHeaderGroups: columnHeaderGroups,
            partitionConfig: partitionConfig,
            showExtraGroupColumn: this.showExtraGroupColumn
          }), !isMenuShown && /*#__PURE__*/_jsx("div", {
            className: "grid-settings-button",
            style: {
              height: "".concat(singleColumnHeaderHeight, "px"),
              width: "".concat(singleColumnHeaderHeight, "px")
            },
            children: /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              "data-testid": "btn-iris-grid-settings-button-".concat(name),
              onClick: this.handleMenu,
              icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: vsMenu,
                transform: "up-1"
              }),
              tooltip: "Table Options"
            })
          }), focusField, loadingElement, filterBar, columnTooltip, advancedFilterMenus, overflowButtonTooltipProps && this.getOverflowButtonTooltip(overflowButtonTooltipProps), expandCellTooltipProps && this.getExpandCellTooltip(expandCellTooltipProps), hoverTooltipProps && this.getHoverTooltip(hoverTooltipProps)]
        }), /*#__PURE__*/_jsx(GotoRow, {
          ref: this.gotoRowRef,
          model: model,
          isShown: isGotoShown,
          gotoRow: gotoRow,
          gotoRowError: gotoRowError,
          gotoValueError: gotoValueError,
          onGotoRowSubmit: this.handleGotoRowSelectedRowNumberSubmit,
          onGotoRowNumberChanged: this.handleGotoRowSelectedRowNumberChanged,
          onClose: this.handleGotoRowClosed,
          onEntering: this.handleAnimationStart,
          onEntered: this.handleAnimationEnd,
          onExiting: () => {
            this.handleAnimationStart();
            this.focus();
          },
          onExited: this.handleAnimationEnd,
          gotoValueSelectedColumnName: gotoValueSelectedColumnName,
          gotoValue: gotoValue,
          gotoValueFilter: gotoValueSelectedFilter,
          onGotoValueSelectedColumnNameChanged: this.handleGotoValueSelectedColumnNameChanged,
          onGotoValueSelectedFilterChanged: this.handleGotoValueSelectedFilterChanged,
          onGotoValueChanged: this.handleGotoValueChanged,
          onGotoValueSubmit: this.handleGotoValueSubmitted
        }), /*#__PURE__*/_jsx(PendingDataBottomBar, {
          error: pendingSaveError,
          isSaving: pendingSavePromise != null,
          saveTooltip: "Commit (".concat(this.commitAction.shortcut.getDisplayText(), ")"),
          discardTooltip: "Discard (".concat(this.discardAction.shortcut.getDisplayText(), ")"),
          pendingDataErrors: pendingDataErrors,
          pendingDataMap: pendingDataMap,
          onEntering: this.handleAnimationStart,
          onEntered: this.handleAnimationEnd,
          onExiting: this.handleAnimationStart,
          onExited: this.handleAnimationEnd,
          onSave: this.handlePendingCommitClicked,
          onDiscard: this.handlePendingDiscardClicked
        }), /*#__PURE__*/_jsx(ToastBottomBar, {
          children: toastMessage
        }), /*#__PURE__*/_jsx(IrisGridCopyHandler, {
          model: model,
          copyOperation: copyOperation !== null && copyOperation !== void 0 ? copyOperation : undefined,
          onEntering: this.handleAnimationStart,
          onEntered: this.handleAnimationEnd,
          onExiting: this.handleAnimationStart,
          onExited: this.handleAnimationEnd
        }), /*#__PURE__*/_jsx(TableSaver, {
          dh: model.dh,
          ref: tableSaver => {
            this.tableSaver = tableSaver;
          },
          getDownloadWorker: getDownloadWorker,
          onDownloadCompleted: this.handleDownloadCompleted,
          onDownloadCanceled: this.handleDownloadCanceled,
          onDownloadProgressUpdate: this.handleDownloadProgressUpdate,
          isDownloading: tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.DOWNLOADING,
          formatter: formatter
        })]
      }), /*#__PURE__*/_jsx(SlideTransition, {
        in: isMenuShown,
        onEntering: this.handleAnimationStart,
        onEntered: this.handleAnimationEnd,
        onExiting: this.handleAnimationStart,
        onExited: this.handleAnimationEnd,
        mountOnEnter: true,
        unmountOnExit: true,
        children: /*#__PURE__*/_jsx("div", {
          className: "table-sidebar",
          children: /*#__PURE__*/_jsx(Stack, {
            children: [/*#__PURE__*/_jsx(Page, {
              title: "Table Options",
              onClose: this.handleMenuClose,
              children: /*#__PURE__*/_jsx(Menu, {
                onSelect: i => this.handleMenuSelect(optionItems[i]),
                items: optionItems
              })
            }, "table-options"), ...openOptionsStack.map((option, i) => /*#__PURE__*/_jsx(Page, {
              title: openOptions[i].title,
              onBack: this.handleMenuBack,
              onClose: this.handleMenuClose,
              children: option
            }, openOptions[i].type))]
          })
        })
      }), /*#__PURE__*/_jsx(ContextActions, {
        actions: this.contextActions
      }), /*#__PURE__*/_jsx(NoPastePermissionModal, {
        isOpen: showNoPastePermissionModal,
        onClose: this.handleCloseNoPastePermissionModal,
        errorMessage: noPastePermissionError
      })]
    });
  }
}
_defineProperty(IrisGrid, "contextType", IrisGridContext);
_defineProperty(IrisGrid, "minDebounce", 150);
_defineProperty(IrisGrid, "maxDebounce", 500);
_defineProperty(IrisGrid, "loadingSpinnerDelay", 800);
_defineProperty(IrisGrid, "defaultProps", {
  advancedFilters: EMPTY_MAP,
  advancedSettings: EMPTY_MAP,
  alwaysFetchColumns: EMPTY_ARRAY,
  conditionalFormats: EMPTY_ARRAY,
  customColumnFormatMap: EMPTY_MAP,
  columnAlignmentMap: EMPTY_MAP,
  isFilterBarShown: false,
  applyInputFiltersOnInit: false,
  movedColumns: EMPTY_ARRAY,
  movedRows: EMPTY_ARRAY,
  inputFilters: EMPTY_ARRAY,
  customFilters: EMPTY_ARRAY,
  onCreateChart: undefined,
  onColumnSelected: () => undefined,
  onDataSelected: () => undefined,
  onError: () => undefined,
  onStateChange: () => undefined,
  onAdvancedSettingsChange: () => undefined,
  partitions: undefined,
  partitionConfig: undefined,
  quickFilters: EMPTY_MAP,
  isQuickFiltersControlled: false,
  onQuickFiltersChange: undefined,
  selectDistinctColumns: EMPTY_ARRAY,
  sorts: EMPTY_ARRAY,
  isSortsControlled: false,
  onSortsChange: undefined,
  reverse: false,
  customColumns: EMPTY_ARRAY,
  aggregationSettings: DEFAULT_AGGREGATION_SETTINGS,
  rollupConfig: undefined,
  userColumnWidths: EMPTY_MAP,
  userColumnWidthsByName: undefined,
  userRowHeights: EMPTY_MAP,
  onSelectionChanged: () => undefined,
  isSelectingColumn: false,
  isSelectingPartition: false,
  isStuckToBottom: false,
  isStuckToRight: false,
  columnAllowedCursor: 'linker',
  columnNotAllowedCursor: 'linker-not-allowed',
  copyCursor: 'copy',
  name: 'table',
  onlyFetchVisibleColumns: true,
  showSearchBar: false,
  searchValue: '',
  invertSearchColumns: true,
  onContextMenu: () => EMPTY_ARRAY,
  pendingDataMap: EMPTY_MAP,
  getDownloadWorker: DownloadServiceWorkerUtils.getServiceWorker,
  settings: {
    timeZone: 'America/New_York',
    defaultDateTimeFormat: DateUtils.FULL_DATE_FORMAT,
    showTimeZone: false,
    showTSeparator: true,
    truncateNumbersWithPound: false,
    showEmptyStrings: true,
    showNullStrings: true,
    showExtraGroupColumn: true,
    formatter: EMPTY_ARRAY
  },
  canCopy: true,
  canDownloadCsv: true,
  frozenColumns: undefined,
  // Do not set a default density prop since we need to know if it overrides the global density setting
  density: undefined,
  canToggleSearch: true,
  mouseHandlers: EMPTY_ARRAY,
  keyHandlers: EMPTY_ARRAY,
  getMetricCalculator: function getMetricCalculator() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new IrisGridMetricCalculator(...args);
  }
});
export default IrisGrid;
//# sourceMappingURL=IrisGrid.js.map